// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { AccountingCreateGlCodeData, AccountingCreateGlCodeErrors, AccountingCreateGlCodeResponses, AccountingCreatePaymentMethodData, AccountingCreatePaymentMethodErrors, AccountingCreatePaymentMethodResponses, AccountingCreateTermsCodeData, AccountingCreateTermsCodeErrors, AccountingCreateTermsCodeResponses, AccountingDeleteGlCodeData, AccountingDeleteGlCodeErrors, AccountingDeleteGlCodeResponses, AccountingDeletePaymentMethodData, AccountingDeletePaymentMethodErrors, AccountingDeletePaymentMethodResponses, AccountingDeleteTermsCodeData, AccountingDeleteTermsCodeErrors, AccountingDeleteTermsCodeResponses, AccountingGetGlCodeData, AccountingGetGlCodeErrors, AccountingGetGlCodeResponses, AccountingGetPaymentMethodData, AccountingGetPaymentMethodErrors, AccountingGetPaymentMethodResponses, AccountingGetTermsCodeData, AccountingGetTermsCodeErrors, AccountingGetTermsCodeResponses, AccountingListGlCodesData, AccountingListGlCodesResponses, AccountingListPaymentMethodsData, AccountingListPaymentMethodsResponses, AccountingListTermsCodesData, AccountingListTermsCodesResponses, AccountingUpdateGlCodeData, AccountingUpdateGlCodeErrors, AccountingUpdateGlCodeResponses, AccountingUpdatePaymentMethodData, AccountingUpdatePaymentMethodErrors, AccountingUpdatePaymentMethodResponses, AccountingUpdateTermsCodeData, AccountingUpdateTermsCodeErrors, AccountingUpdateTermsCodeResponses, AcquireLockData, AcquireLockErrors, AcquireLockResponses, AddOrderNoteData, AddOrderNoteErrors, AddOrderNoteResponses, ArchiveChatSessionData, ArchiveChatSessionErrors, ArchiveChatSessionResponses, AssignArtistData, AssignArtistErrors, AssignArtistResponses, AuthorizePaymentData, AuthorizePaymentErrors, AuthorizePaymentResponses, CalculatePriceData, CalculatePriceResponses, CalculateShipDateData, CalculateShipDateErrors, CalculateShipDateResponses, CapturePaymentData, CapturePaymentErrors, CapturePaymentResponses, ChargePaymentData, ChargePaymentErrors, ChargePaymentResponses, CheckLockData, CheckLockResponses, ClearCartonsData, ClearCartonsErrors, ClearCartonsResponses, CommitDepositsData, CommitDepositsErrors, CommitDepositsResponses, CommitSalesData, CommitSalesErrors, CommitSalesResponses, CompleteArtworkRequestData, CompleteArtworkRequestErrors, CompleteArtworkRequestResponses, CopyOrderData, CopyOrderErrors, CopyOrderResponses, CreateAccessGroupData, CreateAccessGroupErrors, CreateAccessGroupResponses, CreateAckTemplateData, CreateAckTemplateResponses, CreateAlertData, CreateAlertErrors, CreateAlertResponses, CreateArtworkRequestData, CreateArtworkRequestErrors, CreateArtworkRequestResponses, CreateChargeItemData, CreateChargeItemErrors, CreateChargeItemResponses, CreateChatSessionData, CreateChatSessionResponses, CreateColdFoilPrinterData, CreateColdFoilPrinterErrors, CreateColdFoilPrinterResponses, CreateCustomerData, CreateCustomerErrors, CreateCustomerNoteData, CreateCustomerNoteErrors, CreateCustomerNoteResponses, CreateCustomerResponses, CreateCustomerTypeData, CreateCustomerTypeErrors, CreateCustomerTypeResponses, CreateDesignData, CreateDesignErrors, CreateDesignResponses, CreateHpShipMethodData, CreateHpShipMethodErrors, CreateHpShipMethodResponses, CreateLayoutSurfaceBindingData, CreateLayoutSurfaceBindingResponses, CreateLayoutSurfaceProfileData, CreateLayoutSurfaceProfileResponses, CreateLocationCodeData, CreateLocationCodeErrors, CreateLocationCodeResponses, CreateNonShipDateData, CreateNonShipDateErrors, CreateNonShipDateResponses, CreateOptionValueData, CreateOptionValueErrors, CreateOptionValueResponses, CreateOrderData, CreateOrderDocumentData, CreateOrderDocumentErrors, CreateOrderDocumentResponses, CreateOrderErrors, CreateOrderResponses, CreatePaymentProfileData, CreatePaymentProfileErrors, CreatePaymentProfileResponses, CreatePriceDetailData, CreatePriceDetailErrors, CreatePriceDetailResponses, CreatePriceHeaderData, CreatePriceHeaderErrors, CreatePriceHeaderResponses, CreatePrinterData, CreatePrinterErrors, CreatePrinterResponses, CreateProductData, CreateProductErrors, CreateProductResponses, CreateProductSpecData, CreateProductSpecErrors, CreateProductSpecResponses, CreateReturnRecallData, CreateReturnRecallErrors, CreateReturnRecallResponses, CreateShipmentData, CreateShipmentErrors, CreateShipmentResponses, CreateShippingSpecialInstructionData, CreateShippingSpecialInstructionErrors, CreateShippingSpecialInstructionResponses, CreateShipToData, CreateShipToErrors, CreateShipToResponses, CreateTextSnippetData, CreateTextSnippetErrors, CreateTextSnippetResponses, CreateUserData, CreateUserErrors, CreateUserResponses, DeleteAccessGroupData, DeleteAccessGroupErrors, DeleteAccessGroupResponses, DeleteAckTemplateData, DeleteAckTemplateErrors, DeleteAckTemplateResponses, DeleteAlertData, DeleteAlertErrors, DeleteAlertResponses, DeleteArtworkRequestImageData, DeleteArtworkRequestImageErrors, DeleteArtworkRequestImageResponses, DeleteChargeItemData, DeleteChargeItemErrors, DeleteChargeItemResponses, DeleteColdFoilPrinterData, DeleteColdFoilPrinterErrors, DeleteColdFoilPrinterResponses, DeleteCustomerData, DeleteCustomerErrors, DeleteCustomerResponses, DeleteCustomerTypeData, DeleteCustomerTypeErrors, DeleteCustomerTypeResponses, DeleteHpShipMethodData, DeleteHpShipMethodErrors, DeleteHpShipMethodResponses, DeleteJobData, DeleteJobErrors, DeleteJobResponses, DeleteLayoutSurfaceBindingData, DeleteLayoutSurfaceBindingErrors, DeleteLayoutSurfaceProfileData, DeleteLayoutSurfaceProfileErrors, DeleteLocationCodeData, DeleteLocationCodeErrors, DeleteLocationCodeResponses, DeleteNonShipDateData, DeleteNonShipDateErrors, DeleteNonShipDateResponses, DeleteOptionValueData, DeleteOptionValueErrors, DeleteOptionValueResponses, DeleteOrderAttachmentData, DeleteOrderAttachmentErrors, DeleteOrderAttachmentResponses, DeleteOrderDocumentData, DeleteOrderDocumentErrors, DeleteOrderDocumentResponses, DeletePaymentProfileData, DeletePaymentProfileErrors, DeletePaymentProfileResponses, DeletePriceDetailData, DeletePriceDetailErrors, DeletePriceDetailResponses, DeletePriceHeaderData, DeletePriceHeaderErrors, DeletePriceHeaderResponses, DeletePrinterData, DeletePrinterErrors, DeletePrinterResponses, DeleteProductSpecData, DeleteProductSpecErrors, DeleteProductSpecResponses, DeleteShippingSpecialInstructionData, DeleteShippingSpecialInstructionErrors, DeleteShippingSpecialInstructionResponses, DeleteShipToData, DeleteShipToErrors, DeleteShipToResponses, DeleteTextSnippetData, DeleteTextSnippetErrors, DeleteTextSnippetResponses, DeleteUserData, DeleteUserErrors, DeleteUserResponses, DownloadArtworkRequestImageData, DownloadArtworkRequestImageErrors, DownloadArtworkRequestImageResponses, DownloadOrderAttachmentData, DownloadOrderAttachmentErrors, DownloadOrderAttachmentResponses, ExecuteBatchPostData, ExecuteBatchPostErrors, ExecuteBatchPostResponses, ExecuteDepositsData, ExecuteDepositsErrors, ExecuteDepositsResponses, ExportCustomersData, ExportCustomersResponses, ExportDesignsData, ExportDesignsResponses, ExportOrdersData, ExportOrdersResponses, ExportProductsData, ExportProductsResponses, ExportWorldShipData, ExportWorldShipErrors, ExportWorldShipResponses, ForceUnlockData, ForceUnlockResponses, GenerateAcknowledgmentData, GenerateAcknowledgmentErrors, GenerateAcknowledgmentResponses, GenerateArtworkRequestFormData, GenerateArtworkRequestFormErrors, GenerateArtworkRequestFormResponses, GenerateGoldenrodData, GenerateGoldenrodErrors, GenerateGoldenrodResponses, GenerateInvoiceData, GenerateInvoiceErrors, GenerateInvoiceResponses, GeneratePackingListData, GeneratePackingListErrors, GeneratePackingListResponses, GenerateRecallFormData, GenerateRecallFormErrors, GenerateRecallFormResponses, GenerateReturnFormData, GenerateReturnFormErrors, GenerateReturnFormResponses, GetAccessGroupData, GetAccessGroupErrors, GetAccessGroupResponses, GetApiAiAdminSessionsByIdMessagesData, GetApiAiAdminSessionsByIdMessagesErrors, GetApiAiAdminSessionsByIdMessagesResponses, GetApiAiAdminSessionsData, GetApiAiAdminSessionsResponses, GetApiAiAdminStatsData, GetApiAiAdminStatsErrors, GetApiAiAdminStatsResponses, GetApiReportsGeneratedByIdDownloadData, GetApiReportsGeneratedByIdDownloadErrors, GetApiReportsGeneratedByIdDownloadResponses, GetApiReportsGeneratedData, GetApiReportsGeneratedResponses, GetArtworkRequestData, GetArtworkRequestErrors, GetArtworkRequestResponses, GetArtworkRequestsFilterMetadataData, GetArtworkRequestsFilterMetadataResponses, GetBatchMaterializationStatusData, GetBatchMaterializationStatusErrors, GetBatchMaterializationStatusResponses, GetCanonicalGraphData, GetCanonicalGraphErrors, GetCanonicalGraphResponses, GetChargeItemData, GetChargeItemErrors, GetChargeItemResponses, GetChatSessionData, GetChatSessionErrors, GetChatSessionResponses, GetCompanyDefaultsData, GetCompanyDefaultsErrors, GetCompanyDefaultsResponses, GetCustomerArBalanceData, GetCustomerArBalanceErrors, GetCustomerArBalanceResponses, GetCustomerCreditHoldData, GetCustomerCreditHoldResponses, GetCustomerData, GetCustomerErrors, GetCustomerResponses, GetCustomersFilterMetadataData, GetCustomersFilterMetadataResponses, GetDashboardSummaryData, GetDashboardSummaryResponses, GetDepositReportData, GetDepositReportResponses, GetDesignData, GetDesignErrors, GetDesignResponses, GetEmailLogData, GetEmailLogDetailData, GetEmailLogDetailErrors, GetEmailLogDetailResponses, GetEmailLogResponses, GetEmailSettingData, GetEmailSettingErrors, GetEmailSettingResponses, GetEmailSettingsData, GetEmailSettingsResponses, GetFailedJobsData, GetFailedJobsResponses, GetHostedPaymentPageData, GetHostedPaymentPageErrors, GetHostedPaymentPageResponses, GetJobDashboardData, GetJobDashboardResponses, GetJobDetailData, GetJobDetailErrors, GetJobDetailResponses, GetLayoutSurfaceProfileData, GetLayoutSurfaceProfileErrors, GetLayoutSurfaceProfileResponses, GetMaterializationStatusData, GetMaterializationStatusErrors, GetMaterializationStatusResponses, GetOptionData, GetOptionErrors, GetOptionResponses, GetOptionValueData, GetOptionValueErrors, GetOptionValueResponses, GetOrderActivityData, GetOrderActivityErrors, GetOrderActivityResponses, GetOrderChartsData, GetOrderChartsErrors, GetOrderChartsResponses, GetOrderData, GetOrderErrors, GetOrderLineItemsData, GetOrderLineItemsErrors, GetOrderLineItemsResponses, GetOrderResponses, GetOrdersByDivisionData, GetOrdersByDivisionResponses, GetOrdersByManufacturingLocationData, GetOrdersByManufacturingLocationResponses, GetOrdersByMonthData, GetOrdersByMonthResponses, GetOrdersByStatusData, GetOrdersByStatusResponses, GetOrdersFilterMetadataData, GetOrdersFilterMetadataResponses, GetOrderStatusHistoryData, GetOrderStatusHistoryResponses, GetPackDetailsData, GetPackDetailsErrors, GetPackDetailsResponses, GetPriceHeaderData, GetPriceHeaderErrors, GetPriceHeaderResponses, GetPrintJobData, GetPrintJobErrors, GetPrintJobResponses, GetProductData, GetProductErrors, GetProductionBacklogData, GetProductionBacklogResponses, GetProductOrderOptionsData, GetProductOrderOptionsResponses, GetProductResponses, GetProductsFilterMetadataData, GetProductsFilterMetadataResponses, GetProductSpecData, GetProductSpecErrors, GetProductSpecResponses, GetRecentActivityData, GetRecentActivityResponses, GetReturnRecallData, GetReturnRecallErrors, GetReturnRecallResponses, GetRevenueByMonthData, GetRevenueByMonthResponses, GetSalesHistoryData, GetSalesHistoryErrors, GetSalesHistoryResponses, GetSalesRegisterReportData, GetSalesRegisterReportResponses, GetSalesTaxReportData, GetSalesTaxReportResponses, GetShipmentLabelData, GetShipmentLabelErrors, GetShipmentLabelResponses, GetShippingRatesData, GetShippingRatesErrors, GetShippingRatesResponses, GetSucceededJobsData, GetSucceededJobsResponses, GetTaxJarConfigData, GetTaxJarConfigResponses, GetTaxJarLogData, GetTaxJarLogErrors, GetTaxJarLogResponses, GetTextSnippetData, GetTextSnippetErrors, GetTextSnippetResponses, GetTimeSpentChartsData, GetTimeSpentChartsResponses, GetTimeSpentSummaryData, GetTimeSpentSummaryResponses, GetTopCustomersData, GetTopCustomersResponses, GetTopSalesRepsData, GetTopSalesRepsResponses, GetUserData, GetUserErrors, GetUserResponses, GlobalSearchData, GlobalSearchResponses, HealthCheckData, HealthCheckResponses, ImportWorldShipData, ImportWorldShipErrors, ImportWorldShipResponses, ListAccessGroupsData, ListAccessGroupsResponses, ListAckTemplatesData, ListAckTemplatesResponses, ListAlertsData, ListAlertsResponses, ListArtistsData, ListArtistsResponses, ListArtworkRequestImagesData, ListArtworkRequestImagesErrors, ListArtworkRequestImagesResponses, ListArtworkRequestsData, ListArtworkRequestsResponses, ListArtworkStatusCodesData, ListArtworkStatusCodesResponses, ListArtworkStatusHistoryData, ListArtworkStatusHistoryErrors, ListArtworkStatusHistoryResponses, ListChangeLogData, ListChangeLogResponses, ListChargeItemsData, ListChargeItemsResponses, ListChatMessagesData, ListChatMessagesResponses, ListChatSessionsData, ListChatSessionsResponses, ListColdFoilPrintersData, ListColdFoilPrintersResponses, ListCustomerArHistoryData, ListCustomerArHistoryResponses, ListCustomerNotesData, ListCustomerNotesResponses, ListCustomersData, ListCustomersResponses, ListCustomerTypesData, ListCustomerTypesResponses, ListDepositReportPaymentsData, ListDepositReportPaymentsResponses, ListDesignCategoriesData, ListDesignCategoriesResponses, ListDesignsData, ListDesignsResponses, ListDivisionsData, ListDivisionsResponses, ListHpShipMethodsData, ListHpShipMethodsResponses, ListInvoiceEligibleOrdersData, ListInvoiceEligibleOrdersResponses, ListLayoutSurfaceBindingsData, ListLayoutSurfaceBindingsResponses, ListLayoutSurfaceProfilesData, ListLayoutSurfaceProfilesResponses, ListListMastersData, ListListMastersResponses, ListLocationCodesData, ListLocationCodesResponses, ListLockedRecordsData, ListLockedRecordsResponses, ListMenuItemsData, ListMenuItemsResponses, ListNonShipDatesData, ListNonShipDatesResponses, ListOptionFamiliesData, ListOptionFamiliesResponses, ListOptionLinksData, ListOptionLinksResponses, ListOptionsData, ListOptionsResponses, ListOptionValuesData, ListOptionValuesResponses, ListOrderAttachmentsData, ListOrderAttachmentsResponses, ListOrderDocumentsData, ListOrderDocumentsResponses, ListOrderPaymentsData, ListOrderPaymentsErrors, ListOrderPaymentsResponses, ListOrdersData, ListOrderShipmentsData, ListOrderShipmentsErrors, ListOrderShipmentsResponses, ListOrdersResponses, ListOrderStatusesData, ListOrderStatusesResponses, ListPackQueueData, ListPackQueueResponses, ListPaymentProfilesData, ListPaymentProfilesErrors, ListPaymentProfilesResponses, ListPostEligibleOrdersData, ListPostEligibleOrdersResponses, ListPriceHeadersData, ListPriceHeadersResponses, ListPrintersData, ListPrintersResponses, ListPrintJobsData, ListPrintJobsResponses, ListProductsData, ListProductSpecsData, ListProductSpecsResponses, ListProductsResponses, ListProductStatusCodesData, ListProductStatusCodesResponses, ListProductTypesData, ListProductTypesResponses, ListProductUsesData, ListProductUsesResponses, ListReturnRecallReasonCodesData, ListReturnRecallReasonCodesResponses, ListReturnRecallStatusesData, ListReturnRecallStatusesResponses, ListSalesRegisterOrdersData, ListSalesRegisterOrdersResponses, ListSalesRepsData, ListSalesRepsResponses, ListSalesTaxReportEntriesData, ListSalesTaxReportEntriesResponses, ListShipMethodsData, ListShipMethodsResponses, ListShippingDefaultsData, ListShippingDefaultsResponses, ListShippingMethodsData, ListShippingMethodsResponses, ListShippingSpecialInstructionsData, ListShippingSpecialInstructionsResponses, ListShipToData, ListShipToResponses, ListTaxInquiryData, ListTaxInquiryResponses, ListTaxJarLogData, ListTaxJarLogResponses, ListTermsCodesData, ListTermsCodesResponses, ListTextSnippetsData, ListTextSnippetsResponses, ListTimeSpentData, ListTimeSpentResponses, ListUsersData, ListUsersResponses, ListValuesByListData, ListValuesByListResponses, ListWorldShipExportLogData, ListWorldShipExportLogResponses, ListWorldShipImportLogData, ListWorldShipImportLogResponses, LoginData, LoginResponses, LogoutData, LogoutResponses, LookupThreeCxCustomerData, LookupThreeCxCustomerErrors, LookupThreeCxCustomerResponses, OverrideCreditHoldData, OverrideCreditHoldErrors, OverrideCreditHoldResponses, PersistChatMessageData, PersistChatMessageErrors, PersistChatMessageResponses, PingData, PingResponses, PostApiReportsGeneratedData, PostApiReportsGeneratedResponses, PostCashReceiptData, PostCashReceiptErrors, PostCashReceiptResponses, PreviewDepositsData, PreviewDepositsResponses, PreviewEmailTemplateData, PreviewEmailTemplateErrors, PreviewEmailTemplateResponses, PreviewWorldShipImportData, PreviewWorldShipImportErrors, PreviewWorldShipImportResponses, PrintOrderDocumentData, PrintOrderDocumentErrors, PrintOrderDocumentResponses, PublishLayoutSurfaceProfileData, PublishLayoutSurfaceProfileErrors, PublishLayoutSurfaceProfileResponses, QuickPrintData, QuickPrintErrors, QuickPrintResponses, RecalculateOrderTotalsData, RecalculateOrderTotalsErrors, RecalculateOrderTotalsResponses, RefreshData, RefreshResponses, RefreshTokenData, RefreshTokenResponses, RefundPaymentData, RefundPaymentErrors, RefundPaymentResponses, ReindexSearchData, ReindexSearchResponses, ReleaseLockData, ReleaseLockResponses, RenewLockData, RenewLockErrors, RenewLockResponses, ResetPasswordData, ResetPasswordErrors, ResetPasswordResponses, RetryFailedJobData, RetryFailedJobErrors, RetryFailedJobResponses, RetryPrintJobData, RetryPrintJobErrors, RetryPrintJobResponses, SaveCartonsData, SaveCartonsErrors, SaveCartonsResponses, SearchCustomersData, SearchCustomersResponses, SearchDesignsData, SearchDesignsResponses, SearchOrdersData, SearchOrdersResponses, SearchProductsData, SearchProductsResponses, SelectAckTemplateData, SelectAckTemplateErrors, SelectAckTemplateResponses, SendInvoiceEmailAsyncData, SendInvoiceEmailAsyncResponses, SendInvoiceEmailSyncData, SendInvoiceEmailSyncErrors, SendInvoiceEmailSyncResponses, SendOrderConfirmationAsyncData, SendOrderConfirmationAsyncResponses, SendOrderConfirmationSyncData, SendOrderConfirmationSyncErrors, SendOrderConfirmationSyncResponses, SendShippingNotificationAsyncData, SendShippingNotificationAsyncResponses, SendShippingNotificationSyncData, SendShippingNotificationSyncErrors, SendShippingNotificationSyncResponses, StartBatchGoldenrodPrintData, StartBatchGoldenrodPrintErrors, StartBatchGoldenrodPrintResponses, StartBatchInvoiceTransmissionData, StartBatchInvoiceTransmissionResponses, TestColdFoilPrinterConnectionData, TestColdFoilPrinterConnectionErrors, TestColdFoilPrinterConnectionResponses, TestTaxJarConnectionData, TestTaxJarConnectionResponses, TrackShipmentData, TrackShipmentErrors, TrackShipmentResponses, TriggerBatchMaterializationData, TriggerBatchMaterializationErrors, TriggerBatchMaterializationResponses, TriggerMaterializationData, TriggerMaterializationErrors, TriggerMaterializationResponses, TriggerRecurringJobData, TriggerRecurringJobResponses, UpdateAccessGroupData, UpdateAccessGroupErrors, UpdateAccessGroupResponses, UpdateAckTemplateData, UpdateAckTemplateErrors, UpdateAckTemplateResponses, UpdateAlertData, UpdateAlertErrors, UpdateAlertResponses, UpdateArtworkRequestData, UpdateArtworkRequestErrors, UpdateArtworkRequestResponses, UpdateArtworkStatusData, UpdateArtworkStatusErrors, UpdateArtworkStatusResponses, UpdateChargeItemData, UpdateChargeItemErrors, UpdateChargeItemResponses, UpdateChatSessionTitleData, UpdateChatSessionTitleErrors, UpdateChatSessionTitleResponses, UpdateColdFoilPrinterData, UpdateColdFoilPrinterErrors, UpdateColdFoilPrinterResponses, UpdateCompanyDefaultsData, UpdateCompanyDefaultsErrors, UpdateCompanyDefaultsResponses, UpdateCustomerData, UpdateCustomerErrors, UpdateCustomerResponses, UpdateCustomerTypeData, UpdateCustomerTypeErrors, UpdateCustomerTypeResponses, UpdateDesignCategoryData, UpdateDesignCategoryErrors, UpdateDesignCategoryResponses, UpdateDesignData, UpdateDesignErrors, UpdateDesignResponses, UpdateDivisionData, UpdateDivisionErrors, UpdateDivisionResponses, UpdateEmailSettingData, UpdateEmailSettingErrors, UpdateEmailSettingResponses, UpdateHpShipMethodData, UpdateHpShipMethodErrors, UpdateHpShipMethodResponses, UpdateLayoutSurfaceProfileData, UpdateLayoutSurfaceProfileErrors, UpdateLayoutSurfaceProfileResponses, UpdateLocationCodeData, UpdateLocationCodeErrors, UpdateLocationCodeResponses, UpdateMenuItemData, UpdateMenuItemErrors, UpdateMenuItemResponses, UpdateNonShipDateData, UpdateNonShipDateErrors, UpdateNonShipDateResponses, UpdateOptionValueData, UpdateOptionValueErrors, UpdateOptionValueResponses, UpdateOrderChartsData, UpdateOrderChartsErrors, UpdateOrderChartsResponses, UpdateOrderData, UpdateOrderDocumentData, UpdateOrderDocumentErrors, UpdateOrderDocumentResponses, UpdateOrderErrors, UpdateOrderResponses, UpdateOrderStatusData, UpdateOrderStatusErrors, UpdateOrderStatusResponses, UpdateOrderTotalsData, UpdateOrderTotalsErrors, UpdateOrderTotalsResponses, UpdatePriceDetailData, UpdatePriceDetailErrors, UpdatePriceDetailResponses, UpdatePriceHeaderData, UpdatePriceHeaderErrors, UpdatePriceHeaderResponses, UpdatePrinterData, UpdatePrinterErrors, UpdatePrinterResponses, UpdateProductData, UpdateProductErrors, UpdateProductResponses, UpdateProductSpecData, UpdateProductSpecErrors, UpdateProductSpecResponses, UpdateReturnRecallData, UpdateReturnRecallErrors, UpdateReturnRecallResponses, UpdateShippingDefaultData, UpdateShippingDefaultErrors, UpdateShippingDefaultResponses, UpdateShippingSpecialInstructionData, UpdateShippingSpecialInstructionErrors, UpdateShippingSpecialInstructionResponses, UpdateShipToData, UpdateShipToErrors, UpdateShipToResponses, UpdateTextSnippetData, UpdateTextSnippetErrors, UpdateTextSnippetResponses, UpdateUserData, UpdateUserErrors, UpdateUserResponses, UploadArtworkRequestImageData, UploadArtworkRequestImageErrors, UploadArtworkRequestImageResponses, UploadOrderAttachmentData, UploadOrderAttachmentErrors, UploadOrderAttachmentResponses, ValidateShippingAddressData, ValidateShippingAddressErrors, ValidateShippingAddressResponses, VoidPaymentData, VoidPaymentErrors, VoidPaymentResponses, VoidShipmentData, VoidShipmentErrors, VoidShipmentResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const healthCheck = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckData, ThrowOnError>) => (options?.client ?? client).get<HealthCheckResponses, unknown, ThrowOnError>({ url: '/health', ...options });

/**
 * Verify Mediator pipeline dispatches correctly
 */
export const ping = <ThrowOnError extends boolean = false>(options?: Options<PingData, ThrowOnError>) => (options?.client ?? client).get<PingResponses, unknown, ThrowOnError>({ url: '/api/ping', ...options });

/**
 * Authenticate with username and password
 */
export const login = <ThrowOnError extends boolean = false>(options: Options<LoginData, ThrowOnError>) => (options.client ?? client).post<LoginResponses, unknown, ThrowOnError>({
    url: '/api/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh access token using HttpOnly cookie
 */
export const refresh = <ThrowOnError extends boolean = false>(options?: Options<RefreshData, ThrowOnError>) => (options?.client ?? client).post<RefreshResponses, unknown, ThrowOnError>({ url: '/api/auth/refresh', ...options });

/**
 * Refresh access token using explicit refresh token body (for non-browser clients)
 */
export const refreshToken = <ThrowOnError extends boolean = false>(options: Options<RefreshTokenData, ThrowOnError>) => (options.client ?? client).post<RefreshTokenResponses, unknown, ThrowOnError>({
    url: '/api/auth/refresh-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke refresh token and clear cookie
 */
export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>) => (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({ url: '/api/auth/logout', ...options });

/**
 * Get paginated list of users
 */
export const listUsers = <ThrowOnError extends boolean = false>(options?: Options<ListUsersData, ThrowOnError>) => (options?.client ?? client).get<ListUsersResponses, unknown, ThrowOnError>({ url: '/api/admin/users', ...options });

/**
 * Create a new user
 */
export const createUser = <ThrowOnError extends boolean = false>(options: Options<CreateUserData, ThrowOnError>) => (options.client ?? client).post<CreateUserResponses, CreateUserErrors, ThrowOnError>({
    url: '/api/admin/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Soft-delete (deactivate) a user
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options: Options<DeleteUserData, ThrowOnError>) => (options.client ?? client).delete<DeleteUserResponses, DeleteUserErrors, ThrowOnError>({ url: '/api/admin/users/{id}', ...options });

/**
 * Get a single user by ID
 */
export const getUser = <ThrowOnError extends boolean = false>(options: Options<GetUserData, ThrowOnError>) => (options.client ?? client).get<GetUserResponses, GetUserErrors, ThrowOnError>({ url: '/api/admin/users/{id}', ...options });

/**
 * Update an existing user
 */
export const updateUser = <ThrowOnError extends boolean = false>(options: Options<UpdateUserData, ThrowOnError>) => (options.client ?? client).put<UpdateUserResponses, UpdateUserErrors, ThrowOnError>({
    url: '/api/admin/users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin password reset for a user
 */
export const resetPassword = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordData, ThrowOnError>) => (options.client ?? client).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
    url: '/api/admin/users/{id}/reset-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all access groups
 */
export const listAccessGroups = <ThrowOnError extends boolean = false>(options?: Options<ListAccessGroupsData, ThrowOnError>) => (options?.client ?? client).get<ListAccessGroupsResponses, unknown, ThrowOnError>({ url: '/api/admin/access-groups', ...options });

/**
 * Create a new access group
 */
export const createAccessGroup = <ThrowOnError extends boolean = false>(options: Options<CreateAccessGroupData, ThrowOnError>) => (options.client ?? client).post<CreateAccessGroupResponses, CreateAccessGroupErrors, ThrowOnError>({
    url: '/api/admin/access-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an access group (fails if users are assigned)
 */
export const deleteAccessGroup = <ThrowOnError extends boolean = false>(options: Options<DeleteAccessGroupData, ThrowOnError>) => (options.client ?? client).delete<DeleteAccessGroupResponses, DeleteAccessGroupErrors, ThrowOnError>({ url: '/api/admin/access-groups/{id}', ...options });

/**
 * Get a single access group with permissions
 */
export const getAccessGroup = <ThrowOnError extends boolean = false>(options: Options<GetAccessGroupData, ThrowOnError>) => (options.client ?? client).get<GetAccessGroupResponses, GetAccessGroupErrors, ThrowOnError>({ url: '/api/admin/access-groups/{id}', ...options });

/**
 * Update an access group and its permissions
 */
export const updateAccessGroup = <ThrowOnError extends boolean = false>(options: Options<UpdateAccessGroupData, ThrowOnError>) => (options.client ?? client).put<UpdateAccessGroupResponses, UpdateAccessGroupErrors, ThrowOnError>({
    url: '/api/admin/access-groups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all alerts ordered by start date
 */
export const listAlerts = <ThrowOnError extends boolean = false>(options?: Options<ListAlertsData, ThrowOnError>) => (options?.client ?? client).get<ListAlertsResponses, unknown, ThrowOnError>({ url: '/api/admin/alerts', ...options });

/**
 * Create a new alert
 */
export const createAlert = <ThrowOnError extends boolean = false>(options: Options<CreateAlertData, ThrowOnError>) => (options.client ?? client).post<CreateAlertResponses, CreateAlertErrors, ThrowOnError>({
    url: '/api/admin/alerts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an alert
 */
export const deleteAlert = <ThrowOnError extends boolean = false>(options: Options<DeleteAlertData, ThrowOnError>) => (options.client ?? client).delete<DeleteAlertResponses, DeleteAlertErrors, ThrowOnError>({ url: '/api/admin/alerts/{id}', ...options });

/**
 * Update an existing alert
 */
export const updateAlert = <ThrowOnError extends boolean = false>(options: Options<UpdateAlertData, ThrowOnError>) => (options.client ?? client).put<UpdateAlertResponses, UpdateAlertErrors, ThrowOnError>({
    url: '/api/admin/alerts/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Release a record lock
 */
export const releaseLock = <ThrowOnError extends boolean = false>(options: Options<ReleaseLockData, ThrowOnError>) => (options.client ?? client).delete<ReleaseLockResponses, unknown, ThrowOnError>({ url: '/api/locks', ...options });

/**
 * Acquire a record lock for editing
 */
export const acquireLock = <ThrowOnError extends boolean = false>(options: Options<AcquireLockData, ThrowOnError>) => (options.client ?? client).post<AcquireLockResponses, AcquireLockErrors, ThrowOnError>({
    url: '/api/locks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Renew (heartbeat) an existing record lock
 */
export const renewLock = <ThrowOnError extends boolean = false>(options: Options<RenewLockData, ThrowOnError>) => (options.client ?? client).put<RenewLockResponses, RenewLockErrors, ThrowOnError>({
    url: '/api/locks/renew',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check if a record is currently locked
 */
export const checkLock = <ThrowOnError extends boolean = false>(options: Options<CheckLockData, ThrowOnError>) => (options.client ?? client).get<CheckLockResponses, unknown, ThrowOnError>({ url: '/api/locks/{tableName}/{keyFieldValue}', ...options });

/**
 * Get all active locked records
 */
export const listLockedRecords = <ThrowOnError extends boolean = false>(options?: Options<ListLockedRecordsData, ThrowOnError>) => (options?.client ?? client).get<ListLockedRecordsResponses, unknown, ThrowOnError>({ url: '/api/admin/locked-records', ...options });

/**
 * Force unlock a record (admin)
 */
export const forceUnlock = <ThrowOnError extends boolean = false>(options: Options<ForceUnlockData, ThrowOnError>) => (options.client ?? client).delete<ForceUnlockResponses, unknown, ThrowOnError>({ url: '/api/admin/locked-records/{tableName}/{keyFieldValue}', ...options });

/**
 * Get paginated change log entries with optional filters
 */
export const listChangeLog = <ThrowOnError extends boolean = false>(options?: Options<ListChangeLogData, ThrowOnError>) => (options?.client ?? client).get<ListChangeLogResponses, unknown, ThrowOnError>({ url: '/api/admin/change-log', ...options });

/**
 * Get all divisions
 */
export const listDivisions = <ThrowOnError extends boolean = false>(options?: Options<ListDivisionsData, ThrowOnError>) => (options?.client ?? client).get<ListDivisionsResponses, unknown, ThrowOnError>({ url: '/api/admin/divisions', ...options });

/**
 * Update a division
 */
export const updateDivision = <ThrowOnError extends boolean = false>(options: Options<UpdateDivisionData, ThrowOnError>) => (options.client ?? client).put<UpdateDivisionResponses, UpdateDivisionErrors, ThrowOnError>({
    url: '/api/admin/divisions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get company defaults
 */
export const getCompanyDefaults = <ThrowOnError extends boolean = false>(options?: Options<GetCompanyDefaultsData, ThrowOnError>) => (options?.client ?? client).get<GetCompanyDefaultsResponses, GetCompanyDefaultsErrors, ThrowOnError>({ url: '/api/admin/settings', ...options });

/**
 * Update company defaults
 */
export const updateCompanyDefaults = <ThrowOnError extends boolean = false>(options: Options<UpdateCompanyDefaultsData, ThrowOnError>) => (options.client ?? client).put<UpdateCompanyDefaultsResponses, UpdateCompanyDefaultsErrors, ThrowOnError>({
    url: '/api/admin/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all menu items as a tree structure
 */
export const listMenuItems = <ThrowOnError extends boolean = false>(options?: Options<ListMenuItemsData, ThrowOnError>) => (options?.client ?? client).get<ListMenuItemsResponses, unknown, ThrowOnError>({ url: '/api/admin/menu-items', ...options });

/**
 * Update a menu item
 */
export const updateMenuItem = <ThrowOnError extends boolean = false>(options: Options<UpdateMenuItemData, ThrowOnError>) => (options.client ?? client).put<UpdateMenuItemResponses, UpdateMenuItemErrors, ThrowOnError>({
    url: '/api/admin/menu-items/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all sales reps
 */
export const listSalesReps = <ThrowOnError extends boolean = false>(options?: Options<ListSalesRepsData, ThrowOnError>) => (options?.client ?? client).get<ListSalesRepsResponses, unknown, ThrowOnError>({ url: '/api/admin/sales-reps', ...options });

/**
 * Get all terms codes
 */
export const listTermsCodes = <ThrowOnError extends boolean = false>(options?: Options<ListTermsCodesData, ThrowOnError>) => (options?.client ?? client).get<ListTermsCodesResponses, unknown, ThrowOnError>({ url: '/api/admin/terms-codes', ...options });

/**
 * Get all ship methods
 */
export const listShipMethods = <ThrowOnError extends boolean = false>(options?: Options<ListShipMethodsData, ThrowOnError>) => (options?.client ?? client).get<ListShipMethodsResponses, unknown, ThrowOnError>({ url: '/api/admin/ship-methods', ...options });

/**
 * Get all non-ship dates for a year, grouped by date with divisions
 */
export const listNonShipDates = <ThrowOnError extends boolean = false>(options?: Options<ListNonShipDatesData, ThrowOnError>) => (options?.client ?? client).get<ListNonShipDatesResponses, unknown, ThrowOnError>({ url: '/api/admin/non-ship-dates', ...options });

/**
 * Create a non-ship date with division assignments
 */
export const createNonShipDate = <ThrowOnError extends boolean = false>(options: Options<CreateNonShipDateData, ThrowOnError>) => (options.client ?? client).post<CreateNonShipDateResponses, CreateNonShipDateErrors, ThrowOnError>({
    url: '/api/admin/non-ship-dates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete all non-ship date entries for a specific date
 */
export const deleteNonShipDate = <ThrowOnError extends boolean = false>(options: Options<DeleteNonShipDateData, ThrowOnError>) => (options.client ?? client).delete<DeleteNonShipDateResponses, DeleteNonShipDateErrors, ThrowOnError>({ url: '/api/admin/non-ship-dates/{date}', ...options });

/**
 * Update a non-ship date's name and division assignments
 */
export const updateNonShipDate = <ThrowOnError extends boolean = false>(options: Options<UpdateNonShipDateData, ThrowOnError>) => (options.client ?? client).put<UpdateNonShipDateResponses, UpdateNonShipDateErrors, ThrowOnError>({
    url: '/api/admin/non-ship-dates/{date}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all per-division ship methods with surcharges and geo restrictions
 */
export const listHpShipMethods = <ThrowOnError extends boolean = false>(options?: Options<ListHpShipMethodsData, ThrowOnError>) => (options?.client ?? client).get<ListHpShipMethodsResponses, unknown, ThrowOnError>({ url: '/api/admin/hp-ship-methods', ...options });

/**
 * Create a new per-division ship method
 */
export const createHpShipMethod = <ThrowOnError extends boolean = false>(options: Options<CreateHpShipMethodData, ThrowOnError>) => (options.client ?? client).post<CreateHpShipMethodResponses, CreateHpShipMethodErrors, ThrowOnError>({
    url: '/api/admin/hp-ship-methods',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a per-division ship method
 */
export const deleteHpShipMethod = <ThrowOnError extends boolean = false>(options: Options<DeleteHpShipMethodData, ThrowOnError>) => (options.client ?? client).delete<DeleteHpShipMethodResponses, DeleteHpShipMethodErrors, ThrowOnError>({ url: '/api/admin/hp-ship-methods/{divisionId}/{shipMethodId}', ...options });

/**
 * Update an existing per-division ship method
 */
export const updateHpShipMethod = <ThrowOnError extends boolean = false>(options: Options<UpdateHpShipMethodData, ThrowOnError>) => (options.client ?? client).put<UpdateHpShipMethodResponses, UpdateHpShipMethodErrors, ThrowOnError>({
    url: '/api/admin/hp-ship-methods/{divisionId}/{shipMethodId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all shipping special instructions
 */
export const listShippingSpecialInstructions = <ThrowOnError extends boolean = false>(options?: Options<ListShippingSpecialInstructionsData, ThrowOnError>) => (options?.client ?? client).get<ListShippingSpecialInstructionsResponses, unknown, ThrowOnError>({ url: '/api/admin/shipping-special-instructions', ...options });

/**
 * Create a new shipping special instruction
 */
export const createShippingSpecialInstruction = <ThrowOnError extends boolean = false>(options: Options<CreateShippingSpecialInstructionData, ThrowOnError>) => (options.client ?? client).post<CreateShippingSpecialInstructionResponses, CreateShippingSpecialInstructionErrors, ThrowOnError>({
    url: '/api/admin/shipping-special-instructions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a shipping special instruction
 */
export const deleteShippingSpecialInstruction = <ThrowOnError extends boolean = false>(options: Options<DeleteShippingSpecialInstructionData, ThrowOnError>) => (options.client ?? client).delete<DeleteShippingSpecialInstructionResponses, DeleteShippingSpecialInstructionErrors, ThrowOnError>({ url: '/api/admin/shipping-special-instructions/{id}', ...options });

/**
 * Update an existing shipping special instruction
 */
export const updateShippingSpecialInstruction = <ThrowOnError extends boolean = false>(options: Options<UpdateShippingSpecialInstructionData, ThrowOnError>) => (options.client ?? client).put<UpdateShippingSpecialInstructionResponses, UpdateShippingSpecialInstructionErrors, ThrowOnError>({
    url: '/api/admin/shipping-special-instructions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all shipping defaults per division
 */
export const listShippingDefaults = <ThrowOnError extends boolean = false>(options?: Options<ListShippingDefaultsData, ThrowOnError>) => (options?.client ?? client).get<ListShippingDefaultsResponses, unknown, ThrowOnError>({ url: '/api/admin/shipping-defaults', ...options });

/**
 * Update UPS credentials and shipper address for a division
 */
export const updateShippingDefault = <ThrowOnError extends boolean = false>(options: Options<UpdateShippingDefaultData, ThrowOnError>) => (options.client ?? client).put<UpdateShippingDefaultResponses, UpdateShippingDefaultErrors, ThrowOnError>({
    url: '/api/admin/shipping-defaults/{divisionId}/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all production location codes
 */
export const listLocationCodes = <ThrowOnError extends boolean = false>(options?: Options<ListLocationCodesData, ThrowOnError>) => (options?.client ?? client).get<ListLocationCodesResponses, unknown, ThrowOnError>({ url: '/api/admin/location-codes', ...options });

/**
 * Create a new production location code
 */
export const createLocationCode = <ThrowOnError extends boolean = false>(options: Options<CreateLocationCodeData, ThrowOnError>) => (options.client ?? client).post<CreateLocationCodeResponses, CreateLocationCodeErrors, ThrowOnError>({
    url: '/api/admin/location-codes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a production location code
 */
export const deleteLocationCode = <ThrowOnError extends boolean = false>(options: Options<DeleteLocationCodeData, ThrowOnError>) => (options.client ?? client).delete<DeleteLocationCodeResponses, DeleteLocationCodeErrors, ThrowOnError>({ url: '/api/admin/location-codes/{id}', ...options });

/**
 * Update an existing production location code
 */
export const updateLocationCode = <ThrowOnError extends boolean = false>(options: Options<UpdateLocationCodeData, ThrowOnError>) => (options.client ?? client).put<UpdateLocationCodeResponses, UpdateLocationCodeErrors, ThrowOnError>({
    url: '/api/admin/location-codes/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get current TaxJar configuration (read-only, from appsettings)
 */
export const getTaxJarConfig = <ThrowOnError extends boolean = false>(options?: Options<GetTaxJarConfigData, ThrowOnError>) => (options?.client ?? client).get<GetTaxJarConfigResponses, unknown, ThrowOnError>({ url: '/api/admin/taxjar/config', ...options });

/**
 * Test TaxJar API connectivity using the configured credentials
 */
export const testTaxJarConnection = <ThrowOnError extends boolean = false>(options?: Options<TestTaxJarConnectionData, ThrowOnError>) => (options?.client ?? client).post<TestTaxJarConnectionResponses, unknown, ThrowOnError>({ url: '/api/admin/taxjar/test', ...options });

/**
 * Get background job summary counts and recurring job list
 */
export const getJobDashboard = <ThrowOnError extends boolean = false>(options?: Options<GetJobDashboardData, ThrowOnError>) => (options?.client ?? client).get<GetJobDashboardResponses, unknown, ThrowOnError>({ url: '/api/admin/jobs', ...options });

/**
 * Get paginated list of failed background jobs
 */
export const getFailedJobs = <ThrowOnError extends boolean = false>(options?: Options<GetFailedJobsData, ThrowOnError>) => (options?.client ?? client).get<GetFailedJobsResponses, unknown, ThrowOnError>({ url: '/api/admin/jobs/failed', ...options });

/**
 * Get paginated list of recently succeeded background jobs
 */
export const getSucceededJobs = <ThrowOnError extends boolean = false>(options?: Options<GetSucceededJobsData, ThrowOnError>) => (options?.client ?? client).get<GetSucceededJobsResponses, unknown, ThrowOnError>({ url: '/api/admin/jobs/succeeded', ...options });

/**
 * Get detailed state history for a specific background job
 */
export const getJobDetail = <ThrowOnError extends boolean = false>(options: Options<GetJobDetailData, ThrowOnError>) => (options.client ?? client).get<GetJobDetailResponses, GetJobDetailErrors, ThrowOnError>({ url: '/api/admin/jobs/{jobId}', ...options });

/**
 * Retry a failed background job
 */
export const retryFailedJob = <ThrowOnError extends boolean = false>(options: Options<RetryFailedJobData, ThrowOnError>) => (options.client ?? client).post<RetryFailedJobResponses, RetryFailedJobErrors, ThrowOnError>({ url: '/api/admin/jobs/{jobId}/retry', ...options });

/**
 * Delete a background job
 */
export const deleteJob = <ThrowOnError extends boolean = false>(options: Options<DeleteJobData, ThrowOnError>) => (options.client ?? client).post<DeleteJobResponses, DeleteJobErrors, ThrowOnError>({ url: '/api/admin/jobs/{jobId}/delete', ...options });

/**
 * Manually trigger a recurring job to run now
 */
export const triggerRecurringJob = <ThrowOnError extends boolean = false>(options: Options<TriggerRecurringJobData, ThrowOnError>) => (options.client ?? client).post<TriggerRecurringJobResponses, unknown, ThrowOnError>({ url: '/api/admin/jobs/recurring/{id}/trigger', ...options });

/**
 * List time-spent sessions with optional filters
 */
export const listTimeSpent = <ThrowOnError extends boolean = false>(options?: Options<ListTimeSpentData, ThrowOnError>) => (options?.client ?? client).get<ListTimeSpentResponses, unknown, ThrowOnError>({ url: '/api/admin/time-spent', ...options });

/**
 * Aggregate time-spent statistics with per-user rollup
 */
export const getTimeSpentSummary = <ThrowOnError extends boolean = false>(options?: Options<GetTimeSpentSummaryData, ThrowOnError>) => (options?.client ?? client).get<GetTimeSpentSummaryResponses, unknown, ThrowOnError>({ url: '/api/admin/time-spent/summary', ...options });

/**
 * Chart-ready breakdowns of time spent by order, user, and day
 */
export const getTimeSpentCharts = <ThrowOnError extends boolean = false>(options?: Options<GetTimeSpentChartsData, ThrowOnError>) => (options?.client ?? client).get<GetTimeSpentChartsResponses, unknown, ThrowOnError>({ url: '/api/admin/time-spent/charts', ...options });

/**
 * List all layout surface profiles
 */
export const listLayoutSurfaceProfiles = <ThrowOnError extends boolean = false>(options?: Options<ListLayoutSurfaceProfilesData, ThrowOnError>) => (options?.client ?? client).get<ListLayoutSurfaceProfilesResponses, unknown, ThrowOnError>({ url: '/api/admin/layout-surfaces/profiles', ...options });

/**
 * Create a new layout surface profile
 */
export const createLayoutSurfaceProfile = <ThrowOnError extends boolean = false>(options: Options<CreateLayoutSurfaceProfileData, ThrowOnError>) => (options.client ?? client).post<CreateLayoutSurfaceProfileResponses, unknown, ThrowOnError>({
    url: '/api/admin/layout-surfaces/profiles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a layout surface profile
 */
export const deleteLayoutSurfaceProfile = <ThrowOnError extends boolean = false>(options: Options<DeleteLayoutSurfaceProfileData, ThrowOnError>) => (options.client ?? client).delete<unknown, DeleteLayoutSurfaceProfileErrors, ThrowOnError>({ url: '/api/admin/layout-surfaces/profiles/{id}', ...options });

/**
 * Get a layout surface profile by ID
 */
export const getLayoutSurfaceProfile = <ThrowOnError extends boolean = false>(options: Options<GetLayoutSurfaceProfileData, ThrowOnError>) => (options.client ?? client).get<GetLayoutSurfaceProfileResponses, GetLayoutSurfaceProfileErrors, ThrowOnError>({ url: '/api/admin/layout-surfaces/profiles/{id}', ...options });

/**
 * Update a layout surface profile
 */
export const updateLayoutSurfaceProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateLayoutSurfaceProfileData, ThrowOnError>) => (options.client ?? client).put<UpdateLayoutSurfaceProfileResponses, UpdateLayoutSurfaceProfileErrors, ThrowOnError>({
    url: '/api/admin/layout-surfaces/profiles/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publish a draft layout surface profile
 */
export const publishLayoutSurfaceProfile = <ThrowOnError extends boolean = false>(options: Options<PublishLayoutSurfaceProfileData, ThrowOnError>) => (options.client ?? client).post<PublishLayoutSurfaceProfileResponses, PublishLayoutSurfaceProfileErrors, ThrowOnError>({ url: '/api/admin/layout-surfaces/profiles/{id}/publish', ...options });

/**
 * List layout surface bindings
 */
export const listLayoutSurfaceBindings = <ThrowOnError extends boolean = false>(options?: Options<ListLayoutSurfaceBindingsData, ThrowOnError>) => (options?.client ?? client).get<ListLayoutSurfaceBindingsResponses, unknown, ThrowOnError>({ url: '/api/admin/layout-surfaces/bindings', ...options });

/**
 * Create a new product binding to a layout surface profile
 */
export const createLayoutSurfaceBinding = <ThrowOnError extends boolean = false>(options: Options<CreateLayoutSurfaceBindingData, ThrowOnError>) => (options.client ?? client).post<CreateLayoutSurfaceBindingResponses, unknown, ThrowOnError>({
    url: '/api/admin/layout-surfaces/bindings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a product binding
 */
export const deleteLayoutSurfaceBinding = <ThrowOnError extends boolean = false>(options: Options<DeleteLayoutSurfaceBindingData, ThrowOnError>) => (options.client ?? client).delete<unknown, DeleteLayoutSurfaceBindingErrors, ThrowOnError>({ url: '/api/admin/layout-surfaces/bindings/{id}', ...options });

/**
 * Get filter metadata for Customers list columns
 */
export const getCustomersFilterMetadata = <ThrowOnError extends boolean = false>(options?: Options<GetCustomersFilterMetadataData, ThrowOnError>) => (options?.client ?? client).get<GetCustomersFilterMetadataResponses, unknown, ThrowOnError>({ url: '/api/customers/filters', ...options });

/**
 * Get paginated list of customers
 */
export const listCustomers = <ThrowOnError extends boolean = false>(options?: Options<ListCustomersData, ThrowOnError>) => (options?.client ?? client).get<ListCustomersResponses, unknown, ThrowOnError>({ url: '/api/customers', ...options });

/**
 * Create a new customer
 */
export const createCustomer = <ThrowOnError extends boolean = false>(options: Options<CreateCustomerData, ThrowOnError>) => (options.client ?? client).post<CreateCustomerResponses, CreateCustomerErrors, ThrowOnError>({
    url: '/api/customers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Typeahead search for customers
 */
export const searchCustomers = <ThrowOnError extends boolean = false>(options?: Options<SearchCustomersData, ThrowOnError>) => (options?.client ?? client).get<SearchCustomersResponses, unknown, ThrowOnError>({ url: '/api/customers/search', ...options });

/**
 * Soft-delete (deactivate) a customer
 */
export const deleteCustomer = <ThrowOnError extends boolean = false>(options: Options<DeleteCustomerData, ThrowOnError>) => (options.client ?? client).delete<DeleteCustomerResponses, DeleteCustomerErrors, ThrowOnError>({ url: '/api/customers/{custId}', ...options });

/**
 * Get a single customer by ID
 */
export const getCustomer = <ThrowOnError extends boolean = false>(options: Options<GetCustomerData, ThrowOnError>) => (options.client ?? client).get<GetCustomerResponses, GetCustomerErrors, ThrowOnError>({ url: '/api/customers/{custId}', ...options });

/**
 * Update an existing customer
 */
export const updateCustomer = <ThrowOnError extends boolean = false>(options: Options<UpdateCustomerData, ThrowOnError>) => (options.client ?? client).put<UpdateCustomerResponses, UpdateCustomerErrors, ThrowOnError>({
    url: '/api/customers/{custId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check customer credit hold status against Traverse AR data
 */
export const getCustomerCreditHold = <ThrowOnError extends boolean = false>(options: Options<GetCustomerCreditHoldData, ThrowOnError>) => (options.client ?? client).get<GetCustomerCreditHoldResponses, unknown, ThrowOnError>({ url: '/api/customers/{custId}/credit-hold', ...options });

/**
 * Get all ship-to addresses for a customer
 */
export const listShipTo = <ThrowOnError extends boolean = false>(options: Options<ListShipToData, ThrowOnError>) => (options.client ?? client).get<ListShipToResponses, unknown, ThrowOnError>({ url: '/api/customers/{customerId}/ship-to', ...options });

/**
 * Create a new ship-to address
 */
export const createShipTo = <ThrowOnError extends boolean = false>(options: Options<CreateShipToData, ThrowOnError>) => (options.client ?? client).post<CreateShipToResponses, CreateShipToErrors, ThrowOnError>({
    url: '/api/customers/{customerId}/ship-to',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a ship-to address
 */
export const deleteShipTo = <ThrowOnError extends boolean = false>(options: Options<DeleteShipToData, ThrowOnError>) => (options.client ?? client).delete<DeleteShipToResponses, DeleteShipToErrors, ThrowOnError>({ url: '/api/customers/{customerId}/ship-to/{shiptoId}', ...options });

/**
 * Update a ship-to address
 */
export const updateShipTo = <ThrowOnError extends boolean = false>(options: Options<UpdateShipToData, ThrowOnError>) => (options.client ?? client).put<UpdateShipToResponses, UpdateShipToErrors, ThrowOnError>({
    url: '/api/customers/{customerId}/ship-to/{shiptoId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get sales history for a customer
 */
export const getSalesHistory = <ThrowOnError extends boolean = false>(options: Options<GetSalesHistoryData, ThrowOnError>) => (options.client ?? client).get<GetSalesHistoryResponses, GetSalesHistoryErrors, ThrowOnError>({ url: '/api/customers/{customerId}/history', ...options });

/**
 * Get AR balance summary with aging buckets and credit data for a customer
 */
export const getCustomerArBalance = <ThrowOnError extends boolean = false>(options: Options<GetCustomerArBalanceData, ThrowOnError>) => (options.client ?? client).get<GetCustomerArBalanceResponses, GetCustomerArBalanceErrors, ThrowOnError>({ url: '/api/customers/{custId}/ar-balance', ...options });

/**
 * List paginated AR transactions (invoices, credit memos, debit memos) for a customer
 *
 * Returns an empty page if Traverse ERP is unavailable.
 */
export const listCustomerArHistory = <ThrowOnError extends boolean = false>(options: Options<ListCustomerArHistoryData, ThrowOnError>) => (options.client ?? client).get<ListCustomerArHistoryResponses, unknown, ThrowOnError>({ url: '/api/customers/{custId}/ar-history', ...options });

/**
 * Get all customer types, optionally filtered by division
 */
export const listCustomerTypes = <ThrowOnError extends boolean = false>(options?: Options<ListCustomerTypesData, ThrowOnError>) => (options?.client ?? client).get<ListCustomerTypesResponses, unknown, ThrowOnError>({ url: '/api/admin/customer-types', ...options });

/**
 * Create a new customer type
 */
export const createCustomerType = <ThrowOnError extends boolean = false>(options: Options<CreateCustomerTypeData, ThrowOnError>) => (options.client ?? client).post<CreateCustomerTypeResponses, CreateCustomerTypeErrors, ThrowOnError>({
    url: '/api/admin/customer-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a customer type
 */
export const deleteCustomerType = <ThrowOnError extends boolean = false>(options: Options<DeleteCustomerTypeData, ThrowOnError>) => (options.client ?? client).delete<DeleteCustomerTypeResponses, DeleteCustomerTypeErrors, ThrowOnError>({ url: '/api/admin/customer-types/{divisionId}/{id}', ...options });

/**
 * Update a customer type
 */
export const updateCustomerType = <ThrowOnError extends boolean = false>(options: Options<UpdateCustomerTypeData, ThrowOnError>) => (options.client ?? client).put<UpdateCustomerTypeResponses, UpdateCustomerTypeErrors, ThrowOnError>({
    url: '/api/admin/customer-types/{divisionId}/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all notes for a customer
 */
export const listCustomerNotes = <ThrowOnError extends boolean = false>(options: Options<ListCustomerNotesData, ThrowOnError>) => (options.client ?? client).get<ListCustomerNotesResponses, unknown, ThrowOnError>({ url: '/api/customers/{custId}/notes', ...options });

/**
 * Create a new note on a customer
 */
export const createCustomerNote = <ThrowOnError extends boolean = false>(options: Options<CreateCustomerNoteData, ThrowOnError>) => (options.client ?? client).post<CreateCustomerNoteResponses, CreateCustomerNoteErrors, ThrowOnError>({
    url: '/api/customers/{custId}/notes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lookup a customer for the 3CX CRM popup by phone number
 */
export const lookupThreeCxCustomer = <ThrowOnError extends boolean = false>(options: Options<LookupThreeCxCustomerData, ThrowOnError>) => (options.client ?? client).get<LookupThreeCxCustomerResponses, LookupThreeCxCustomerErrors, ThrowOnError>({ url: '/api/3cx/lookup', ...options });

/**
 * Get paginated, filterable design list
 */
export const listDesigns = <ThrowOnError extends boolean = false>(options?: Options<ListDesignsData, ThrowOnError>) => (options?.client ?? client).get<ListDesignsResponses, unknown, ThrowOnError>({ url: '/api/designs', ...options });

/**
 * Create a new design
 */
export const createDesign = <ThrowOnError extends boolean = false>(options: Options<CreateDesignData, ThrowOnError>) => (options.client ?? client).post<CreateDesignResponses, CreateDesignErrors, ThrowOnError>({
    url: '/api/designs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Typeahead search for designs
 */
export const searchDesigns = <ThrowOnError extends boolean = false>(options?: Options<SearchDesignsData, ThrowOnError>) => (options?.client ?? client).get<SearchDesignsResponses, unknown, ThrowOnError>({ url: '/api/designs/search', ...options });

/**
 * Get a single design with variations and product uses
 */
export const getDesign = <ThrowOnError extends boolean = false>(options: Options<GetDesignData, ThrowOnError>) => (options.client ?? client).get<GetDesignResponses, GetDesignErrors, ThrowOnError>({ url: '/api/designs/{valueId}', ...options });

/**
 * Update a design (with record lock)
 */
export const updateDesign = <ThrowOnError extends boolean = false>(options: Options<UpdateDesignData, ThrowOnError>) => (options.client ?? client).put<UpdateDesignResponses, UpdateDesignErrors, ThrowOnError>({
    url: '/api/designs/{valueId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get design category tree
 */
export const listDesignCategories = <ThrowOnError extends boolean = false>(options?: Options<ListDesignCategoriesData, ThrowOnError>) => (options?.client ?? client).get<ListDesignCategoriesResponses, unknown, ThrowOnError>({ url: '/api/designs/categories', ...options });

/**
 * Update a design category
 */
export const updateDesignCategory = <ThrowOnError extends boolean = false>(options: Options<UpdateDesignCategoryData, ThrowOnError>) => (options.client ?? client).put<UpdateDesignCategoryResponses, UpdateDesignCategoryErrors, ThrowOnError>({
    url: '/api/designs/categories/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get filter metadata for Orders list columns
 */
export const getOrdersFilterMetadata = <ThrowOnError extends boolean = false>(options?: Options<GetOrdersFilterMetadataData, ThrowOnError>) => (options?.client ?? client).get<GetOrdersFilterMetadataResponses, unknown, ThrowOnError>({ url: '/api/orders/filters', ...options });

/**
 * Get paginated list of orders
 */
export const listOrders = <ThrowOnError extends boolean = false>(options?: Options<ListOrdersData, ThrowOnError>) => (options?.client ?? client).get<ListOrdersResponses, unknown, ThrowOnError>({ url: '/api/orders', ...options });

/**
 * Create a new order
 */
export const createOrder = <ThrowOnError extends boolean = false>(options: Options<CreateOrderData, ThrowOnError>) => (options.client ?? client).post<CreateOrderResponses, CreateOrderErrors, ThrowOnError>({
    url: '/api/orders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all order status codes
 */
export const listOrderStatuses = <ThrowOnError extends boolean = false>(options?: Options<ListOrderStatusesData, ThrowOnError>) => (options?.client ?? client).get<ListOrderStatusesResponses, unknown, ThrowOnError>({ url: '/api/orders/statuses', ...options });

/**
 * Typeahead search for orders
 */
export const searchOrders = <ThrowOnError extends boolean = false>(options?: Options<SearchOrdersData, ThrowOnError>) => (options?.client ?? client).get<SearchOrdersResponses, unknown, ThrowOnError>({ url: '/api/orders/search', ...options });

/**
 * Get a single order by TransId
 */
export const getOrder = <ThrowOnError extends boolean = false>(options: Options<GetOrderData, ThrowOnError>) => (options.client ?? client).get<GetOrderResponses, GetOrderErrors, ThrowOnError>({ url: '/api/orders/{transId}', ...options });

/**
 * Update an existing order
 */
export const updateOrder = <ThrowOnError extends boolean = false>(options: Options<UpdateOrderData, ThrowOnError>) => (options.client ?? client).put<UpdateOrderResponses, UpdateOrderErrors, ThrowOnError>({
    url: '/api/orders/{transId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get line items for an order
 */
export const getOrderLineItems = <ThrowOnError extends boolean = false>(options: Options<GetOrderLineItemsData, ThrowOnError>) => (options.client ?? client).get<GetOrderLineItemsResponses, GetOrderLineItemsErrors, ThrowOnError>({ url: '/api/orders/{transId}/line-items', ...options });

/**
 * Get activity log for an order
 */
export const getOrderActivity = <ThrowOnError extends boolean = false>(options: Options<GetOrderActivityData, ThrowOnError>) => (options.client ?? client).get<GetOrderActivityResponses, GetOrderActivityErrors, ThrowOnError>({ url: '/api/orders/{transId}/activity', ...options });

/**
 * Add a manual note to the order activity log
 */
export const addOrderNote = <ThrowOnError extends boolean = false>(options: Options<AddOrderNoteData, ThrowOnError>) => (options.client ?? client).post<AddOrderNoteResponses, AddOrderNoteErrors, ThrowOnError>({
    url: '/api/orders/{transId}/activity',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all documents/notes for an order
 */
export const listOrderDocuments = <ThrowOnError extends boolean = false>(options: Options<ListOrderDocumentsData, ThrowOnError>) => (options.client ?? client).get<ListOrderDocumentsResponses, unknown, ThrowOnError>({ url: '/api/orders/{transId}/documents', ...options });

/**
 * Create a new document/note for an order
 */
export const createOrderDocument = <ThrowOnError extends boolean = false>(options: Options<CreateOrderDocumentData, ThrowOnError>) => (options.client ?? client).post<CreateOrderDocumentResponses, CreateOrderDocumentErrors, ThrowOnError>({
    url: '/api/orders/{transId}/documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get chart data for an order
 */
export const getOrderCharts = <ThrowOnError extends boolean = false>(options: Options<GetOrderChartsData, ThrowOnError>) => (options.client ?? client).get<GetOrderChartsResponses, GetOrderChartsErrors, ThrowOnError>({ url: '/api/orders/{transId}/charts', ...options });

/**
 * Replace all chart data for an order
 */
export const updateOrderCharts = <ThrowOnError extends boolean = false>(options: Options<UpdateOrderChartsData, ThrowOnError>) => (options.client ?? client).put<UpdateOrderChartsResponses, UpdateOrderChartsErrors, ThrowOnError>({
    url: '/api/orders/{transId}/charts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all file attachments for an order
 */
export const listOrderAttachments = <ThrowOnError extends boolean = false>(options: Options<ListOrderAttachmentsData, ThrowOnError>) => (options.client ?? client).get<ListOrderAttachmentsResponses, unknown, ThrowOnError>({ url: '/api/orders/{transId}/attachments', ...options });

/**
 * Upload a file attachment to an order
 */
export const uploadOrderAttachment = <ThrowOnError extends boolean = false>(options: Options<UploadOrderAttachmentData, ThrowOnError>) => (options.client ?? client).post<UploadOrderAttachmentResponses, UploadOrderAttachmentErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/orders/{transId}/attachments',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Download an attachment file
 */
export const downloadOrderAttachment = <ThrowOnError extends boolean = false>(options: Options<DownloadOrderAttachmentData, ThrowOnError>) => (options.client ?? client).get<DownloadOrderAttachmentResponses, DownloadOrderAttachmentErrors, ThrowOnError>({ url: '/api/orders/{transId}/attachments/{seq}/download', ...options });

/**
 * Get the canonical print-line graph for an order line
 */
export const getCanonicalGraph = <ThrowOnError extends boolean = false>(options: Options<GetCanonicalGraphData, ThrowOnError>) => (options.client ?? client).get<GetCanonicalGraphResponses, GetCanonicalGraphErrors, ThrowOnError>({ url: '/api/orders/{transId}/lines/{entryNum}/canonical', ...options });

/**
 * Get the latest materialization job status for an order line
 */
export const getMaterializationStatus = <ThrowOnError extends boolean = false>(options: Options<GetMaterializationStatusData, ThrowOnError>) => (options.client ?? client).get<GetMaterializationStatusResponses, GetMaterializationStatusErrors, ThrowOnError>({ url: '/api/orders/{transId}/lines/{entryNum}/materialize/status', ...options });

/**
 * Get materialization job status for all lines in an order
 */
export const getBatchMaterializationStatus = <ThrowOnError extends boolean = false>(options: Options<GetBatchMaterializationStatusData, ThrowOnError>) => (options.client ?? client).get<GetBatchMaterializationStatusResponses, GetBatchMaterializationStatusErrors, ThrowOnError>({ url: '/api/orders/{transId}/materialize/status', ...options });

/**
 * Recalculate order totals
 */
export const recalculateOrderTotals = <ThrowOnError extends boolean = false>(options: Options<RecalculateOrderTotalsData, ThrowOnError>) => (options.client ?? client).post<RecalculateOrderTotalsResponses, RecalculateOrderTotalsErrors, ThrowOnError>({ url: '/api/orders/{transId}/recalculate', ...options });

/**
 * Change order status
 */
export const updateOrderStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateOrderStatusData, ThrowOnError>) => (options.client ?? client).put<UpdateOrderStatusResponses, UpdateOrderStatusErrors, ThrowOnError>({
    url: '/api/orders/{transId}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update order totals (freight, misc, discount, tax)
 */
export const updateOrderTotals = <ThrowOnError extends boolean = false>(options: Options<UpdateOrderTotalsData, ThrowOnError>) => (options.client ?? client).put<UpdateOrderTotalsResponses, UpdateOrderTotalsErrors, ThrowOnError>({
    url: '/api/orders/{transId}/totals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Copy an existing order into a new draft
 */
export const copyOrder = <ThrowOnError extends boolean = false>(options: Options<CopyOrderData, ThrowOnError>) => (options.client ?? client).post<CopyOrderResponses, CopyOrderErrors, ThrowOnError>({ url: '/api/orders/{transId}/copy', ...options });

/**
 * Override a credit hold on an order (supervisor only)
 */
export const overrideCreditHold = <ThrowOnError extends boolean = false>(options: Options<OverrideCreditHoldData, ThrowOnError>) => (options.client ?? client).post<OverrideCreditHoldResponses, OverrideCreditHoldErrors, ThrowOnError>({
    url: '/api/orders/{transId}/credit-hold-override',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a document/note from an order
 */
export const deleteOrderDocument = <ThrowOnError extends boolean = false>(options: Options<DeleteOrderDocumentData, ThrowOnError>) => (options.client ?? client).delete<DeleteOrderDocumentResponses, DeleteOrderDocumentErrors, ThrowOnError>({ url: '/api/orders/{transId}/documents/{id}', ...options });

/**
 * Update an existing document/note for an order
 */
export const updateOrderDocument = <ThrowOnError extends boolean = false>(options: Options<UpdateOrderDocumentData, ThrowOnError>) => (options.client ?? client).put<UpdateOrderDocumentResponses, UpdateOrderDocumentErrors, ThrowOnError>({
    url: '/api/orders/{transId}/documents/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an attachment from an order
 */
export const deleteOrderAttachment = <ThrowOnError extends boolean = false>(options: Options<DeleteOrderAttachmentData, ThrowOnError>) => (options.client ?? client).delete<DeleteOrderAttachmentResponses, DeleteOrderAttachmentErrors, ThrowOnError>({ url: '/api/orders/{transId}/attachments/{seq}', ...options });

/**
 * Trigger print-line materialization for a single order line
 */
export const triggerMaterialization = <ThrowOnError extends boolean = false>(options: Options<TriggerMaterializationData, ThrowOnError>) => (options.client ?? client).post<TriggerMaterializationResponses, TriggerMaterializationErrors, ThrowOnError>({ url: '/api/orders/{transId}/lines/{entryNum}/materialize', ...options });

/**
 * Trigger print-line materialization for all lines in an order
 */
export const triggerBatchMaterialization = <ThrowOnError extends boolean = false>(options: Options<TriggerBatchMaterializationData, ThrowOnError>) => (options.client ?? client).post<TriggerBatchMaterializationResponses, TriggerBatchMaterializationErrors, ThrowOnError>({ url: '/api/orders/{transId}/materialize', ...options });

/**
 * Get all return/recall status codes
 */
export const listReturnRecallStatuses = <ThrowOnError extends boolean = false>(options?: Options<ListReturnRecallStatusesData, ThrowOnError>) => (options?.client ?? client).get<ListReturnRecallStatusesResponses, unknown, ThrowOnError>({ url: '/api/orders/return-recall-statuses', ...options });

/**
 * Get all return/recall reason codes
 */
export const listReturnRecallReasonCodes = <ThrowOnError extends boolean = false>(options?: Options<ListReturnRecallReasonCodesData, ThrowOnError>) => (options?.client ?? client).get<ListReturnRecallReasonCodesResponses, unknown, ThrowOnError>({ url: '/api/orders/return-recall-reason-codes', ...options });

/**
 * Get return/recall details for an order
 */
export const getReturnRecall = <ThrowOnError extends boolean = false>(options: Options<GetReturnRecallData, ThrowOnError>) => (options.client ?? client).get<GetReturnRecallResponses, GetReturnRecallErrors, ThrowOnError>({ url: '/api/orders/{transId}/return-recall', ...options });

/**
 * Create return/recall for an order
 */
export const createReturnRecall = <ThrowOnError extends boolean = false>(options: Options<CreateReturnRecallData, ThrowOnError>) => (options.client ?? client).post<CreateReturnRecallResponses, CreateReturnRecallErrors, ThrowOnError>({
    url: '/api/orders/{transId}/return-recall',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update return/recall for an order
 */
export const updateReturnRecall = <ThrowOnError extends boolean = false>(options: Options<UpdateReturnRecallData, ThrowOnError>) => (options.client ?? client).put<UpdateReturnRecallResponses, UpdateReturnRecallErrors, ThrowOnError>({
    url: '/api/orders/{transId}/return-recall',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get filter metadata for Products list columns
 */
export const getProductsFilterMetadata = <ThrowOnError extends boolean = false>(options?: Options<GetProductsFilterMetadataData, ThrowOnError>) => (options?.client ?? client).get<GetProductsFilterMetadataResponses, unknown, ThrowOnError>({ url: '/api/products/filters', ...options });

/**
 * Get paginated list of products
 */
export const listProducts = <ThrowOnError extends boolean = false>(options?: Options<ListProductsData, ThrowOnError>) => (options?.client ?? client).get<ListProductsResponses, unknown, ThrowOnError>({ url: '/api/products', ...options });

/**
 * Create a new product
 */
export const createProduct = <ThrowOnError extends boolean = false>(options: Options<CreateProductData, ThrowOnError>) => (options.client ?? client).post<CreateProductResponses, CreateProductErrors, ThrowOnError>({
    url: '/api/products',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all product use codes
 */
export const listProductUses = <ThrowOnError extends boolean = false>(options?: Options<ListProductUsesData, ThrowOnError>) => (options?.client ?? client).get<ListProductUsesResponses, unknown, ThrowOnError>({ url: '/api/products/product-uses', ...options });

/**
 * Get all product type codes
 */
export const listProductTypes = <ThrowOnError extends boolean = false>(options?: Options<ListProductTypesData, ThrowOnError>) => (options?.client ?? client).get<ListProductTypesResponses, unknown, ThrowOnError>({ url: '/api/products/product-types', ...options });

/**
 * Get all product status codes
 */
export const listProductStatusCodes = <ThrowOnError extends boolean = false>(options?: Options<ListProductStatusCodesData, ThrowOnError>) => (options?.client ?? client).get<ListProductStatusCodesResponses, unknown, ThrowOnError>({ url: '/api/products/product-status-codes', ...options });

/**
 * Typeahead search for products
 */
export const searchProducts = <ThrowOnError extends boolean = false>(options?: Options<SearchProductsData, ThrowOnError>) => (options?.client ?? client).get<SearchProductsResponses, unknown, ThrowOnError>({ url: '/api/products/search', ...options });

/**
 * Get a single product by ID
 */
export const getProduct = <ThrowOnError extends boolean = false>(options: Options<GetProductData, ThrowOnError>) => (options.client ?? client).get<GetProductResponses, GetProductErrors, ThrowOnError>({ url: '/api/products/{id}', ...options });

/**
 * Update an existing product
 */
export const updateProduct = <ThrowOnError extends boolean = false>(options: Options<UpdateProductData, ThrowOnError>) => (options.client ?? client).put<UpdateProductResponses, UpdateProductErrors, ThrowOnError>({
    url: '/api/products/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all options
 */
export const listOptions = <ThrowOnError extends boolean = false>(options?: Options<ListOptionsData, ThrowOnError>) => (options?.client ?? client).get<ListOptionsResponses, unknown, ThrowOnError>({ url: '/api/options', ...options });

/**
 * Get a single option by ID
 */
export const getOption = <ThrowOnError extends boolean = false>(options: Options<GetOptionData, ThrowOnError>) => (options.client ?? client).get<GetOptionResponses, GetOptionErrors, ThrowOnError>({ url: '/api/options/{optionId}', ...options });

/**
 * Get option links for an option
 */
export const listOptionLinks = <ThrowOnError extends boolean = false>(options: Options<ListOptionLinksData, ThrowOnError>) => (options.client ?? client).get<ListOptionLinksResponses, unknown, ThrowOnError>({ url: '/api/options/{optionId}/links', ...options });

/**
 * Get all option list masters
 */
export const listListMasters = <ThrowOnError extends boolean = false>(options?: Options<ListListMastersData, ThrowOnError>) => (options?.client ?? client).get<ListListMastersResponses, unknown, ThrowOnError>({ url: '/api/lists', ...options });

/**
 * Get option values in a specific list
 */
export const listValuesByList = <ThrowOnError extends boolean = false>(options: Options<ListValuesByListData, ThrowOnError>) => (options.client ?? client).get<ListValuesByListResponses, unknown, ThrowOnError>({ url: '/api/lists/{listId}/values', ...options });

/**
 * Get available product options for order entry
 */
export const getProductOrderOptions = <ThrowOnError extends boolean = false>(options: Options<GetProductOrderOptionsData, ThrowOnError>) => (options.client ?? client).get<GetProductOrderOptionsResponses, unknown, ThrowOnError>({ url: '/api/products/{productId}/order-options', ...options });

/**
 * Get all option families with their members
 */
export const listOptionFamilies = <ThrowOnError extends boolean = false>(options?: Options<ListOptionFamiliesData, ThrowOnError>) => (options?.client ?? client).get<ListOptionFamiliesResponses, unknown, ThrowOnError>({ url: '/api/option-families', ...options });

/**
 * Get paginated list of option values
 */
export const listOptionValues = <ThrowOnError extends boolean = false>(options?: Options<ListOptionValuesData, ThrowOnError>) => (options?.client ?? client).get<ListOptionValuesResponses, unknown, ThrowOnError>({ url: '/api/admin/option-values', ...options });

/**
 * Create a new option value
 */
export const createOptionValue = <ThrowOnError extends boolean = false>(options: Options<CreateOptionValueData, ThrowOnError>) => (options.client ?? client).post<CreateOptionValueResponses, CreateOptionValueErrors, ThrowOnError>({
    url: '/api/admin/option-values',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an option value
 */
export const deleteOptionValue = <ThrowOnError extends boolean = false>(options: Options<DeleteOptionValueData, ThrowOnError>) => (options.client ?? client).delete<DeleteOptionValueResponses, DeleteOptionValueErrors, ThrowOnError>({ url: '/api/admin/option-values/{valueId}', ...options });

/**
 * Get a single option value by ID
 */
export const getOptionValue = <ThrowOnError extends boolean = false>(options: Options<GetOptionValueData, ThrowOnError>) => (options.client ?? client).get<GetOptionValueResponses, GetOptionValueErrors, ThrowOnError>({ url: '/api/admin/option-values/{valueId}', ...options });

/**
 * Update an existing option value
 */
export const updateOptionValue = <ThrowOnError extends boolean = false>(options: Options<UpdateOptionValueData, ThrowOnError>) => (options.client ?? client).put<UpdateOptionValueResponses, UpdateOptionValueErrors, ThrowOnError>({
    url: '/api/admin/option-values/{valueId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get paginated list of charge items
 */
export const listChargeItems = <ThrowOnError extends boolean = false>(options?: Options<ListChargeItemsData, ThrowOnError>) => (options?.client ?? client).get<ListChargeItemsResponses, unknown, ThrowOnError>({ url: '/api/admin/charge-items', ...options });

/**
 * Create a new charge item
 */
export const createChargeItem = <ThrowOnError extends boolean = false>(options: Options<CreateChargeItemData, ThrowOnError>) => (options.client ?? client).post<CreateChargeItemResponses, CreateChargeItemErrors, ThrowOnError>({
    url: '/api/admin/charge-items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a charge item
 */
export const deleteChargeItem = <ThrowOnError extends boolean = false>(options: Options<DeleteChargeItemData, ThrowOnError>) => (options.client ?? client).delete<DeleteChargeItemResponses, DeleteChargeItemErrors, ThrowOnError>({ url: '/api/admin/charge-items/{valueId}', ...options });

/**
 * Get a single charge item by ID
 */
export const getChargeItem = <ThrowOnError extends boolean = false>(options: Options<GetChargeItemData, ThrowOnError>) => (options.client ?? client).get<GetChargeItemResponses, GetChargeItemErrors, ThrowOnError>({ url: '/api/admin/charge-items/{valueId}', ...options });

/**
 * Update an existing charge item
 */
export const updateChargeItem = <ThrowOnError extends boolean = false>(options: Options<UpdateChargeItemData, ThrowOnError>) => (options.client ?? client).put<UpdateChargeItemResponses, UpdateChargeItemErrors, ThrowOnError>({
    url: '/api/admin/charge-items/{valueId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview price calculation for a product with options
 */
export const calculatePrice = <ThrowOnError extends boolean = false>(options: Options<CalculatePriceData, ThrowOnError>) => (options.client ?? client).post<CalculatePriceResponses, unknown, ThrowOnError>({
    url: '/api/pricing/calculate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all price headers for a product
 */
export const listPriceHeaders = <ThrowOnError extends boolean = false>(options: Options<ListPriceHeadersData, ThrowOnError>) => (options.client ?? client).get<ListPriceHeadersResponses, unknown, ThrowOnError>({ url: '/api/products/{productId}/pricing', ...options });

/**
 * Create a new price header for a product
 */
export const createPriceHeader = <ThrowOnError extends boolean = false>(options: Options<CreatePriceHeaderData, ThrowOnError>) => (options.client ?? client).post<CreatePriceHeaderResponses, CreatePriceHeaderErrors, ThrowOnError>({
    url: '/api/products/{productId}/pricing',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a price header and all its detail lines
 */
export const deletePriceHeader = <ThrowOnError extends boolean = false>(options: Options<DeletePriceHeaderData, ThrowOnError>) => (options.client ?? client).delete<DeletePriceHeaderResponses, DeletePriceHeaderErrors, ThrowOnError>({ url: '/api/products/{productId}/pricing/{headerId}', ...options });

/**
 * Get a single price header with detail lines
 */
export const getPriceHeader = <ThrowOnError extends boolean = false>(options: Options<GetPriceHeaderData, ThrowOnError>) => (options.client ?? client).get<GetPriceHeaderResponses, GetPriceHeaderErrors, ThrowOnError>({ url: '/api/products/{productId}/pricing/{headerId}', ...options });

/**
 * Update a price header
 */
export const updatePriceHeader = <ThrowOnError extends boolean = false>(options: Options<UpdatePriceHeaderData, ThrowOnError>) => (options.client ?? client).put<UpdatePriceHeaderResponses, UpdatePriceHeaderErrors, ThrowOnError>({
    url: '/api/products/{productId}/pricing/{headerId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add a quantity break tier to a price header
 */
export const createPriceDetail = <ThrowOnError extends boolean = false>(options: Options<CreatePriceDetailData, ThrowOnError>) => (options.client ?? client).post<CreatePriceDetailResponses, CreatePriceDetailErrors, ThrowOnError>({
    url: '/api/products/{productId}/pricing/{headerId}/details',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a price detail line
 */
export const deletePriceDetail = <ThrowOnError extends boolean = false>(options: Options<DeletePriceDetailData, ThrowOnError>) => (options.client ?? client).delete<DeletePriceDetailResponses, DeletePriceDetailErrors, ThrowOnError>({ url: '/api/products/{productId}/pricing/{headerId}/details/{detailId}', ...options });

/**
 * Update a price detail line
 */
export const updatePriceDetail = <ThrowOnError extends boolean = false>(options: Options<UpdatePriceDetailData, ThrowOnError>) => (options.client ?? client).put<UpdatePriceDetailResponses, UpdatePriceDetailErrors, ThrowOnError>({
    url: '/api/products/{productId}/pricing/{headerId}/details/{detailId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all text snippets, optionally filtered by record type
 */
export const listTextSnippets = <ThrowOnError extends boolean = false>(options?: Options<ListTextSnippetsData, ThrowOnError>) => (options?.client ?? client).get<ListTextSnippetsResponses, unknown, ThrowOnError>({ url: '/api/products/text-snippets', ...options });

/**
 * Create a new text snippet
 */
export const createTextSnippet = <ThrowOnError extends boolean = false>(options: Options<CreateTextSnippetData, ThrowOnError>) => (options.client ?? client).post<CreateTextSnippetResponses, CreateTextSnippetErrors, ThrowOnError>({
    url: '/api/products/text-snippets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a text snippet
 */
export const deleteTextSnippet = <ThrowOnError extends boolean = false>(options: Options<DeleteTextSnippetData, ThrowOnError>) => (options.client ?? client).delete<DeleteTextSnippetResponses, DeleteTextSnippetErrors, ThrowOnError>({ url: '/api/products/text-snippets/{id}', ...options });

/**
 * Get a text snippet by ID
 */
export const getTextSnippet = <ThrowOnError extends boolean = false>(options: Options<GetTextSnippetData, ThrowOnError>) => (options.client ?? client).get<GetTextSnippetResponses, GetTextSnippetErrors, ThrowOnError>({ url: '/api/products/text-snippets/{id}', ...options });

/**
 * Update an existing text snippet
 */
export const updateTextSnippet = <ThrowOnError extends boolean = false>(options: Options<UpdateTextSnippetData, ThrowOnError>) => (options.client ?? client).put<UpdateTextSnippetResponses, UpdateTextSnippetErrors, ThrowOnError>({
    url: '/api/products/text-snippets/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a paginated list of product specifications
 */
export const listProductSpecs = <ThrowOnError extends boolean = false>(options?: Options<ListProductSpecsData, ThrowOnError>) => (options?.client ?? client).get<ListProductSpecsResponses, unknown, ThrowOnError>({ url: '/api/products/specs', ...options });

/**
 * Create a new product specification
 */
export const createProductSpec = <ThrowOnError extends boolean = false>(options: Options<CreateProductSpecData, ThrowOnError>) => (options.client ?? client).post<CreateProductSpecResponses, CreateProductSpecErrors, ThrowOnError>({
    url: '/api/products/specs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a product specification
 */
export const deleteProductSpec = <ThrowOnError extends boolean = false>(options: Options<DeleteProductSpecData, ThrowOnError>) => (options.client ?? client).delete<DeleteProductSpecResponses, DeleteProductSpecErrors, ThrowOnError>({ url: '/api/products/specs/{id}', ...options });

/**
 * Get a product specification by ID
 */
export const getProductSpec = <ThrowOnError extends boolean = false>(options: Options<GetProductSpecData, ThrowOnError>) => (options.client ?? client).get<GetProductSpecResponses, GetProductSpecErrors, ThrowOnError>({ url: '/api/products/specs/{id}', ...options });

/**
 * Update an existing product specification
 */
export const updateProductSpec = <ThrowOnError extends boolean = false>(options: Options<UpdateProductSpecData, ThrowOnError>) => (options.client ?? client).put<UpdateProductSpecResponses, UpdateProductSpecErrors, ThrowOnError>({
    url: '/api/products/specs/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List payment transactions for an order
 */
export const listOrderPayments = <ThrowOnError extends boolean = false>(options: Options<ListOrderPaymentsData, ThrowOnError>) => (options.client ?? client).get<ListOrderPaymentsResponses, ListOrderPaymentsErrors, ThrowOnError>({ url: '/api/orders/{transId}/payments', ...options });

/**
 * Get Accept.js hosted payment page token
 */
export const getHostedPaymentPage = <ThrowOnError extends boolean = false>(options: Options<GetHostedPaymentPageData, ThrowOnError>) => (options.client ?? client).get<GetHostedPaymentPageResponses, GetHostedPaymentPageErrors, ThrowOnError>({ url: '/api/orders/{transId}/payments/hosted-page', ...options });

/**
 * Authorize (hold) a payment without capturing
 */
export const authorizePayment = <ThrowOnError extends boolean = false>(options: Options<AuthorizePaymentData, ThrowOnError>) => (options.client ?? client).post<AuthorizePaymentResponses, AuthorizePaymentErrors, ThrowOnError>({
    url: '/api/orders/{transId}/payments/authorize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Authorize and capture a payment in one step
 */
export const chargePayment = <ThrowOnError extends boolean = false>(options: Options<ChargePaymentData, ThrowOnError>) => (options.client ?? client).post<ChargePaymentResponses, ChargePaymentErrors, ThrowOnError>({
    url: '/api/orders/{transId}/payments/charge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Capture a previously authorized payment
 */
export const capturePayment = <ThrowOnError extends boolean = false>(options: Options<CapturePaymentData, ThrowOnError>) => (options.client ?? client).post<CapturePaymentResponses, CapturePaymentErrors, ThrowOnError>({
    url: '/api/orders/{transId}/payments/{seq}/capture',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Void an unsettled transaction
 */
export const voidPayment = <ThrowOnError extends boolean = false>(options: Options<VoidPaymentData, ThrowOnError>) => (options.client ?? client).post<VoidPaymentResponses, VoidPaymentErrors, ThrowOnError>({ url: '/api/orders/{transId}/payments/{seq}/void', ...options });

/**
 * Refund a settled transaction
 */
export const refundPayment = <ThrowOnError extends boolean = false>(options: Options<RefundPaymentData, ThrowOnError>) => (options.client ?? client).post<RefundPaymentResponses, RefundPaymentErrors, ThrowOnError>({
    url: '/api/orders/{transId}/payments/{seq}/refund',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List saved payment profiles for a customer
 */
export const listPaymentProfiles = <ThrowOnError extends boolean = false>(options: Options<ListPaymentProfilesData, ThrowOnError>) => (options.client ?? client).get<ListPaymentProfilesResponses, ListPaymentProfilesErrors, ThrowOnError>({ url: '/api/customers/{custId}/payment-profiles', ...options });

/**
 * Save a new payment profile for a customer
 */
export const createPaymentProfile = <ThrowOnError extends boolean = false>(options: Options<CreatePaymentProfileData, ThrowOnError>) => (options.client ?? client).post<CreatePaymentProfileResponses, CreatePaymentProfileErrors, ThrowOnError>({
    url: '/api/customers/{custId}/payment-profiles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a saved payment profile
 */
export const deletePaymentProfile = <ThrowOnError extends boolean = false>(options: Options<DeletePaymentProfileData, ThrowOnError>) => (options.client ?? client).delete<DeletePaymentProfileResponses, DeletePaymentProfileErrors, ThrowOnError>({ url: '/api/customers/{custId}/payment-profiles/{paymentProfileId}', ...options });

/**
 * Get shipping rate quotes for a destination
 */
export const getShippingRates = <ThrowOnError extends boolean = false>(options: Options<GetShippingRatesData, ThrowOnError>) => (options.client ?? client).post<GetShippingRatesResponses, GetShippingRatesErrors, ThrowOnError>({
    url: '/api/shipping/rates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validate a shipping address via UPS
 */
export const validateShippingAddress = <ThrowOnError extends boolean = false>(options: Options<ValidateShippingAddressData, ThrowOnError>) => (options.client ?? client).post<ValidateShippingAddressResponses, ValidateShippingAddressErrors, ThrowOnError>({
    url: '/api/shipping/validate-address',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List available shipping methods
 */
export const listShippingMethods = <ThrowOnError extends boolean = false>(options?: Options<ListShippingMethodsData, ThrowOnError>) => (options?.client ?? client).get<ListShippingMethodsResponses, unknown, ThrowOnError>({ url: '/api/shipping/methods', ...options });

/**
 * Calculate ship-by date based on delivery date and transit time
 */
export const calculateShipDate = <ThrowOnError extends boolean = false>(options: Options<CalculateShipDateData, ThrowOnError>) => (options.client ?? client).post<CalculateShipDateResponses, CalculateShipDateErrors, ThrowOnError>({
    url: '/api/shipping/calculate-ship-date',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get live UPS tracking status for a tracking number
 */
export const trackShipment = <ThrowOnError extends boolean = false>(options: Options<TrackShipmentData, ThrowOnError>) => (options.client ?? client).post<TrackShipmentResponses, TrackShipmentErrors, ThrowOnError>({
    url: '/api/shipping/track',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List orders in INSHIP status ready for packing
 */
export const listPackQueue = <ThrowOnError extends boolean = false>(options?: Options<ListPackQueueData, ThrowOnError>) => (options?.client ?? client).get<ListPackQueueResponses, unknown, ThrowOnError>({ url: '/api/shipping/pack-queue', ...options });

/**
 * Get pack details for an order with line items and carton contents
 */
export const getPackDetails = <ThrowOnError extends boolean = false>(options: Options<GetPackDetailsData, ThrowOnError>) => (options.client ?? client).get<GetPackDetailsResponses, GetPackDetailsErrors, ThrowOnError>({ url: '/api/shipping/pack-queue/{transId}', ...options });

/**
 * Remove all carton contents for an order
 */
export const clearCartons = <ThrowOnError extends boolean = false>(options: Options<ClearCartonsData, ThrowOnError>) => (options.client ?? client).delete<ClearCartonsResponses, ClearCartonsErrors, ThrowOnError>({ url: '/api/shipping/pack-queue/{transId}/cartons', ...options });

/**
 * Create or replace carton contents for an order
 */
export const saveCartons = <ThrowOnError extends boolean = false>(options: Options<SaveCartonsData, ThrowOnError>) => (options.client ?? client).post<SaveCartonsResponses, SaveCartonsErrors, ThrowOnError>({
    url: '/api/shipping/pack-queue/{transId}/cartons',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate WorldShip-compatible tab-delimited export file from INSHIP orders
 */
export const exportWorldShip = <ThrowOnError extends boolean = false>(options: Options<ExportWorldShipData, ThrowOnError>) => (options.client ?? client).post<ExportWorldShipResponses, ExportWorldShipErrors, ThrowOnError>({
    url: '/api/shipping/worldship/export',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List WorldShip export log entries with pagination
 */
export const listWorldShipExportLog = <ThrowOnError extends boolean = false>(options?: Options<ListWorldShipExportLogData, ThrowOnError>) => (options?.client ?? client).get<ListWorldShipExportLogResponses, unknown, ThrowOnError>({ url: '/api/shipping/worldship/export-log', ...options });

/**
 * Upload and process a WorldShip return CSV file
 */
export const importWorldShip = <ThrowOnError extends boolean = false>(options: Options<ImportWorldShipData, ThrowOnError>) => (options.client ?? client).post<ImportWorldShipResponses, ImportWorldShipErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/shipping/worldship/import',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Preview a WorldShip CSV import without writing data
 */
export const previewWorldShipImport = <ThrowOnError extends boolean = false>(options: Options<PreviewWorldShipImportData, ThrowOnError>) => (options.client ?? client).post<PreviewWorldShipImportResponses, PreviewWorldShipImportErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/shipping/worldship/import/preview',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List WorldShip import processing log entries
 */
export const listWorldShipImportLog = <ThrowOnError extends boolean = false>(options?: Options<ListWorldShipImportLogData, ThrowOnError>) => (options?.client ?? client).get<ListWorldShipImportLogResponses, unknown, ThrowOnError>({ url: '/api/shipping/worldship/import-log', ...options });

/**
 * List shipment packages for an order
 */
export const listOrderShipments = <ThrowOnError extends boolean = false>(options: Options<ListOrderShipmentsData, ThrowOnError>) => (options.client ?? client).get<ListOrderShipmentsResponses, ListOrderShipmentsErrors, ThrowOnError>({ url: '/api/orders/{transId}/shipments', ...options });

/**
 * Create a UPS shipment via API for an order
 */
export const createShipment = <ThrowOnError extends boolean = false>(options: Options<CreateShipmentData, ThrowOnError>) => (options.client ?? client).post<CreateShipmentResponses, CreateShipmentErrors, ThrowOnError>({
    url: '/api/orders/{transId}/shipments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Void a shipment package
 */
export const voidShipment = <ThrowOnError extends boolean = false>(options: Options<VoidShipmentData, ThrowOnError>) => (options.client ?? client).post<VoidShipmentResponses, VoidShipmentErrors, ThrowOnError>({ url: '/api/orders/{transId}/shipments/{seq}/void', ...options });

/**
 * Download the shipping label for a package
 */
export const getShipmentLabel = <ThrowOnError extends boolean = false>(options: Options<GetShipmentLabelData, ThrowOnError>) => (options.client ?? client).get<GetShipmentLabelResponses, GetShipmentLabelErrors, ThrowOnError>({ url: '/api/orders/{transId}/shipments/{seq}/label', ...options });

/**
 * Get aggregated KPI metrics for the landing page dashboard
 */
export const getDashboardSummary = <ThrowOnError extends boolean = false>(options?: Options<GetDashboardSummaryData, ThrowOnError>) => (options?.client ?? client).get<GetDashboardSummaryResponses, unknown, ThrowOnError>({ url: '/api/dashboard/summary', ...options });

/**
 * Get order counts grouped by status for the dashboard bar chart
 */
export const getOrdersByStatus = <ThrowOnError extends boolean = false>(options?: Options<GetOrdersByStatusData, ThrowOnError>) => (options?.client ?? client).get<GetOrdersByStatusResponses, unknown, ThrowOnError>({ url: '/api/dashboard/orders/by-status', ...options });

/**
 * Get order counts grouped by status over time for the dashboard trend line chart
 */
export const getOrderStatusHistory = <ThrowOnError extends boolean = false>(options?: Options<GetOrderStatusHistoryData, ThrowOnError>) => (options?.client ?? client).get<GetOrderStatusHistoryResponses, unknown, ThrowOnError>({ url: '/api/dashboard/orders/status-history', ...options });

/**
 * Get recent change log entries for the dashboard activity feed
 */
export const getRecentActivity = <ThrowOnError extends boolean = false>(options?: Options<GetRecentActivityData, ThrowOnError>) => (options?.client ?? client).get<GetRecentActivityResponses, unknown, ThrowOnError>({ url: '/api/dashboard/recent-activity', ...options });

/**
 * Get order counts bucketed by time period for the dashboard line chart
 */
export const getOrdersByMonth = <ThrowOnError extends boolean = false>(options?: Options<GetOrdersByMonthData, ThrowOnError>) => (options?.client ?? client).get<GetOrdersByMonthResponses, unknown, ThrowOnError>({ url: '/api/dashboard/orders/by-month', ...options });

/**
 * Get revenue totals bucketed by time period for the dashboard line chart
 */
export const getRevenueByMonth = <ThrowOnError extends boolean = false>(options?: Options<GetRevenueByMonthData, ThrowOnError>) => (options?.client ?? client).get<GetRevenueByMonthResponses, unknown, ThrowOnError>({ url: '/api/dashboard/revenue/by-month', ...options });

/**
 * Get top customers ranked by revenue for the dashboard bar chart
 */
export const getTopCustomers = <ThrowOnError extends boolean = false>(options?: Options<GetTopCustomersData, ThrowOnError>) => (options?.client ?? client).get<GetTopCustomersResponses, unknown, ThrowOnError>({ url: '/api/dashboard/customers/top', ...options });

/**
 * Get production and artwork queue metrics for the production dashboard
 */
export const getProductionBacklog = <ThrowOnError extends boolean = false>(options?: Options<GetProductionBacklogData, ThrowOnError>) => (options?.client ?? client).get<GetProductionBacklogResponses, unknown, ThrowOnError>({ url: '/api/dashboard/production/backlog', ...options });

/**
 * Get order counts grouped by division for the dashboard pie chart
 */
export const getOrdersByDivision = <ThrowOnError extends boolean = false>(options?: Options<GetOrdersByDivisionData, ThrowOnError>) => (options?.client ?? client).get<GetOrdersByDivisionResponses, unknown, ThrowOnError>({ url: '/api/dashboard/orders/by-division', ...options });

/**
 * Get top sales representatives ranked by order count for the dashboard bar chart
 */
export const getTopSalesReps = <ThrowOnError extends boolean = false>(options?: Options<GetTopSalesRepsData, ThrowOnError>) => (options?.client ?? client).get<GetTopSalesRepsResponses, unknown, ThrowOnError>({ url: '/api/dashboard/sales-reps/top', ...options });

/**
 * Get order counts grouped by manufacturing location for the manufacturing dashboard
 */
export const getOrdersByManufacturingLocation = <ThrowOnError extends boolean = false>(options?: Options<GetOrdersByManufacturingLocationData, ThrowOnError>) => (options?.client ?? client).get<GetOrdersByManufacturingLocationResponses, unknown, ThrowOnError>({ url: '/api/dashboard/orders/by-manufacturing-location', ...options });

/**
 * Generate a PDF invoice for an order
 */
export const generateInvoice = <ThrowOnError extends boolean = false>(options: Options<GenerateInvoiceData, ThrowOnError>) => (options.client ?? client).get<GenerateInvoiceResponses, GenerateInvoiceErrors, ThrowOnError>({ url: '/api/reports/invoices/{transId}', ...options });

/**
 * Generate a goldenrod production ticket PDF for an order
 */
export const generateGoldenrod = <ThrowOnError extends boolean = false>(options: Options<GenerateGoldenrodData, ThrowOnError>) => (options.client ?? client).get<GenerateGoldenrodResponses, GenerateGoldenrodErrors, ThrowOnError>({ url: '/api/reports/goldenrod/{transId}', ...options });

/**
 * Generate a packing list PDF for an order
 */
export const generatePackingList = <ThrowOnError extends boolean = false>(options: Options<GeneratePackingListData, ThrowOnError>) => (options.client ?? client).get<GeneratePackingListResponses, GeneratePackingListErrors, ThrowOnError>({ url: '/api/reports/packing-list/{transId}', ...options });

/**
 * Generate a recall form PDF for an order
 */
export const generateRecallForm = <ThrowOnError extends boolean = false>(options: Options<GenerateRecallFormData, ThrowOnError>) => (options.client ?? client).get<GenerateRecallFormResponses, GenerateRecallFormErrors, ThrowOnError>({ url: '/api/reports/recall/{transId}', ...options });

/**
 * Generate a return form PDF for an order
 */
export const generateReturnForm = <ThrowOnError extends boolean = false>(options: Options<GenerateReturnFormData, ThrowOnError>) => (options.client ?? client).get<GenerateReturnFormResponses, GenerateReturnFormErrors, ThrowOnError>({ url: '/api/reports/return/{transId}', ...options });

/**
 * Generate an acknowledgment PDF for an order using a template
 */
export const generateAcknowledgment = <ThrowOnError extends boolean = false>(options: Options<GenerateAcknowledgmentData, ThrowOnError>) => (options.client ?? client).get<GenerateAcknowledgmentResponses, GenerateAcknowledgmentErrors, ThrowOnError>({ url: '/api/reports/acknowledgment/{transId}', ...options });

/**
 * Generate an artwork request form PDF
 */
export const generateArtworkRequestForm = <ThrowOnError extends boolean = false>(options: Options<GenerateArtworkRequestFormData, ThrowOnError>) => (options.client ?? client).get<GenerateArtworkRequestFormResponses, GenerateArtworkRequestFormErrors, ThrowOnError>({ url: '/api/reports/artwork-request/{id}', ...options });

/**
 * Export filtered orders to Excel
 */
export const exportOrders = <ThrowOnError extends boolean = false>(options: Options<ExportOrdersData, ThrowOnError>) => (options.client ?? client).get<ExportOrdersResponses, unknown, ThrowOnError>({ url: '/api/reports/export/orders', ...options });

/**
 * Export filtered customers to Excel
 */
export const exportCustomers = <ThrowOnError extends boolean = false>(options: Options<ExportCustomersData, ThrowOnError>) => (options.client ?? client).get<ExportCustomersResponses, unknown, ThrowOnError>({ url: '/api/reports/export/customers', ...options });

/**
 * Export filtered products to Excel
 */
export const exportProducts = <ThrowOnError extends boolean = false>(options: Options<ExportProductsData, ThrowOnError>) => (options.client ?? client).get<ExportProductsResponses, unknown, ThrowOnError>({ url: '/api/reports/export/products', ...options });

/**
 * Export filtered designs to Excel
 */
export const exportDesigns = <ThrowOnError extends boolean = false>(options: Options<ExportDesignsData, ThrowOnError>) => (options.client ?? client).get<ExportDesignsResponses, unknown, ThrowOnError>({ url: '/api/reports/export/designs', ...options });

/**
 * List generated reports for the current user
 */
export const getApiReportsGenerated = <ThrowOnError extends boolean = false>(options?: Options<GetApiReportsGeneratedData, ThrowOnError>) => (options?.client ?? client).get<GetApiReportsGeneratedResponses, unknown, ThrowOnError>({ url: '/api/reports/generated', ...options });

/**
 * Queue a new report for background generation
 */
export const postApiReportsGenerated = <ThrowOnError extends boolean = false>(options: Options<PostApiReportsGeneratedData, ThrowOnError>) => (options.client ?? client).post<PostApiReportsGeneratedResponses, unknown, ThrowOnError>({
    url: '/api/reports/generated',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download a completed generated report
 */
export const getApiReportsGeneratedByIdDownload = <ThrowOnError extends boolean = false>(options: Options<GetApiReportsGeneratedByIdDownloadData, ThrowOnError>) => (options.client ?? client).get<GetApiReportsGeneratedByIdDownloadResponses, GetApiReportsGeneratedByIdDownloadErrors, ThrowOnError>({ url: '/api/reports/generated/{id}/download', ...options });

/**
 * Enqueue an order confirmation email for background sending
 */
export const sendOrderConfirmationAsync = <ThrowOnError extends boolean = false>(options: Options<SendOrderConfirmationAsyncData, ThrowOnError>) => (options.client ?? client).post<SendOrderConfirmationAsyncResponses, unknown, ThrowOnError>({ url: '/api/emails/send/order-confirmation/{transId}', ...options });

/**
 * Send an order confirmation email synchronously
 */
export const sendOrderConfirmationSync = <ThrowOnError extends boolean = false>(options: Options<SendOrderConfirmationSyncData, ThrowOnError>) => (options.client ?? client).post<SendOrderConfirmationSyncResponses, SendOrderConfirmationSyncErrors, ThrowOnError>({ url: '/api/emails/send/order-confirmation/{transId}/sync', ...options });

/**
 * Enqueue an invoice email for background sending
 */
export const sendInvoiceEmailAsync = <ThrowOnError extends boolean = false>(options: Options<SendInvoiceEmailAsyncData, ThrowOnError>) => (options.client ?? client).post<SendInvoiceEmailAsyncResponses, unknown, ThrowOnError>({ url: '/api/emails/send/invoice/{transId}', ...options });

/**
 * Send an invoice email synchronously
 */
export const sendInvoiceEmailSync = <ThrowOnError extends boolean = false>(options: Options<SendInvoiceEmailSyncData, ThrowOnError>) => (options.client ?? client).post<SendInvoiceEmailSyncResponses, SendInvoiceEmailSyncErrors, ThrowOnError>({
    url: '/api/emails/send/invoice/{transId}/sync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enqueue a shipping notification email for background sending
 */
export const sendShippingNotificationAsync = <ThrowOnError extends boolean = false>(options: Options<SendShippingNotificationAsyncData, ThrowOnError>) => (options.client ?? client).post<SendShippingNotificationAsyncResponses, unknown, ThrowOnError>({ url: '/api/emails/send/shipping-notification/{transId}', ...options });

/**
 * Send a shipping notification email synchronously
 */
export const sendShippingNotificationSync = <ThrowOnError extends boolean = false>(options: Options<SendShippingNotificationSyncData, ThrowOnError>) => (options.client ?? client).post<SendShippingNotificationSyncResponses, SendShippingNotificationSyncErrors, ThrowOnError>({ url: '/api/emails/send/shipping-notification/{transId}/sync', ...options });

/**
 * Get paginated email log entries
 */
export const getEmailLog = <ThrowOnError extends boolean = false>(options?: Options<GetEmailLogData, ThrowOnError>) => (options?.client ?? client).get<GetEmailLogResponses, unknown, ThrowOnError>({ url: '/api/emails/log', ...options });

/**
 * Get a single email log entry with full details including HTML body
 */
export const getEmailLogDetail = <ThrowOnError extends boolean = false>(options: Options<GetEmailLogDetailData, ThrowOnError>) => (options.client ?? client).get<GetEmailLogDetailResponses, GetEmailLogDetailErrors, ThrowOnError>({ url: '/api/emails/log/{id}', ...options });

/**
 * List all email settings
 */
export const getEmailSettings = <ThrowOnError extends boolean = false>(options?: Options<GetEmailSettingsData, ThrowOnError>) => (options?.client ?? client).get<GetEmailSettingsResponses, unknown, ThrowOnError>({ url: '/api/emails/settings', ...options });

/**
 * Get a single email setting by ID
 */
export const getEmailSetting = <ThrowOnError extends boolean = false>(options: Options<GetEmailSettingData, ThrowOnError>) => (options.client ?? client).get<GetEmailSettingResponses, GetEmailSettingErrors, ThrowOnError>({ url: '/api/emails/settings/{id}', ...options });

/**
 * Update an email setting
 */
export const updateEmailSetting = <ThrowOnError extends boolean = false>(options: Options<UpdateEmailSettingData, ThrowOnError>) => (options.client ?? client).put<UpdateEmailSettingResponses, UpdateEmailSettingErrors, ThrowOnError>({
    url: '/api/emails/settings/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Render an email template with sample data for preview
 */
export const previewEmailTemplate = <ThrowOnError extends boolean = false>(options: Options<PreviewEmailTemplateData, ThrowOnError>) => (options.client ?? client).get<PreviewEmailTemplateResponses, PreviewEmailTemplateErrors, ThrowOnError>({ url: '/api/emails/settings/preview/{templateType}', ...options });

/**
 * Get filter metadata for ArtworkRequests list columns
 */
export const getArtworkRequestsFilterMetadata = <ThrowOnError extends boolean = false>(options?: Options<GetArtworkRequestsFilterMetadataData, ThrowOnError>) => (options?.client ?? client).get<GetArtworkRequestsFilterMetadataResponses, unknown, ThrowOnError>({ url: '/api/artwork-requests/filters', ...options });

/**
 * Get paginated list of artwork requests
 */
export const listArtworkRequests = <ThrowOnError extends boolean = false>(options?: Options<ListArtworkRequestsData, ThrowOnError>) => (options?.client ?? client).get<ListArtworkRequestsResponses, unknown, ThrowOnError>({ url: '/api/artwork-requests', ...options });

/**
 * Create a new artwork request for an order
 */
export const createArtworkRequest = <ThrowOnError extends boolean = false>(options: Options<CreateArtworkRequestData, ThrowOnError>) => (options.client ?? client).post<CreateArtworkRequestResponses, CreateArtworkRequestErrors, ThrowOnError>({
    url: '/api/artwork-requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get art-eligible users from Art1 and Creative1 access groups
 */
export const listArtists = <ThrowOnError extends boolean = false>(options?: Options<ListArtistsData, ThrowOnError>) => (options?.client ?? client).get<ListArtistsResponses, unknown, ThrowOnError>({ url: '/api/artwork-requests/artists', ...options });

/**
 * Get all artwork status codes ordered by sequence
 */
export const listArtworkStatusCodes = <ThrowOnError extends boolean = false>(options?: Options<ListArtworkStatusCodesData, ThrowOnError>) => (options?.client ?? client).get<ListArtworkStatusCodesResponses, unknown, ThrowOnError>({ url: '/api/artwork-requests/status-codes', ...options });

/**
 * Get a single artwork request by ID
 */
export const getArtworkRequest = <ThrowOnError extends boolean = false>(options: Options<GetArtworkRequestData, ThrowOnError>) => (options.client ?? client).get<GetArtworkRequestResponses, GetArtworkRequestErrors, ThrowOnError>({ url: '/api/artwork-requests/{id}', ...options });

/**
 * Update an existing artwork request
 */
export const updateArtworkRequest = <ThrowOnError extends boolean = false>(options: Options<UpdateArtworkRequestData, ThrowOnError>) => (options.client ?? client).put<UpdateArtworkRequestResponses, UpdateArtworkRequestErrors, ThrowOnError>({
    url: '/api/artwork-requests/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get status update history for an artwork request
 */
export const listArtworkStatusHistory = <ThrowOnError extends boolean = false>(options: Options<ListArtworkStatusHistoryData, ThrowOnError>) => (options.client ?? client).get<ListArtworkStatusHistoryResponses, ListArtworkStatusHistoryErrors, ThrowOnError>({ url: '/api/artwork-requests/{id}/status-history', ...options });

/**
 * Get additional images for an artwork request
 */
export const listArtworkRequestImages = <ThrowOnError extends boolean = false>(options: Options<ListArtworkRequestImagesData, ThrowOnError>) => (options.client ?? client).get<ListArtworkRequestImagesResponses, ListArtworkRequestImagesErrors, ThrowOnError>({ url: '/api/artwork-requests/{id}/images', ...options });

/**
 * Upload an additional detail image for an artwork request
 */
export const uploadArtworkRequestImage = <ThrowOnError extends boolean = false>(options: Options<UploadArtworkRequestImageData, ThrowOnError>) => (options.client ?? client).post<UploadArtworkRequestImageResponses, UploadArtworkRequestImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/artwork-requests/{id}/images',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Download an artwork request image file
 */
export const downloadArtworkRequestImage = <ThrowOnError extends boolean = false>(options: Options<DownloadArtworkRequestImageData, ThrowOnError>) => (options.client ?? client).get<DownloadArtworkRequestImageResponses, DownloadArtworkRequestImageErrors, ThrowOnError>({ url: '/api/artwork-requests/{id}/images/{imageId}/download', ...options });

/**
 * Add a status update to an artwork request
 */
export const updateArtworkStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateArtworkStatusData, ThrowOnError>) => (options.client ?? client).post<UpdateArtworkStatusResponses, UpdateArtworkStatusErrors, ThrowOnError>({
    url: '/api/artwork-requests/{id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assign or unassign an artist to an artwork request
 */
export const assignArtist = <ThrowOnError extends boolean = false>(options: Options<AssignArtistData, ThrowOnError>) => (options.client ?? client).post<AssignArtistResponses, AssignArtistErrors, ThrowOnError>({
    url: '/api/artwork-requests/{id}/assign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark an artwork request as complete with completion details
 */
export const completeArtworkRequest = <ThrowOnError extends boolean = false>(options: Options<CompleteArtworkRequestData, ThrowOnError>) => (options.client ?? client).post<CompleteArtworkRequestResponses, CompleteArtworkRequestErrors, ThrowOnError>({
    url: '/api/artwork-requests/{id}/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an additional detail image from an artwork request
 */
export const deleteArtworkRequestImage = <ThrowOnError extends boolean = false>(options: Options<DeleteArtworkRequestImageData, ThrowOnError>) => (options.client ?? client).delete<DeleteArtworkRequestImageResponses, DeleteArtworkRequestImageErrors, ThrowOnError>({ url: '/api/artwork-requests/{id}/images/{imageId}', ...options });

/**
 * Dispatch a document to a FolderMill printer
 */
export const printOrderDocument = <ThrowOnError extends boolean = false>(options: Options<PrintOrderDocumentData, ThrowOnError>) => (options.client ?? client).post<PrintOrderDocumentResponses, PrintOrderDocumentErrors, ThrowOnError>({
    url: '/api/printing/print',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Quick print acknowledgment to default printer without preview
 */
export const quickPrint = <ThrowOnError extends boolean = false>(options: Options<QuickPrintData, ThrowOnError>) => (options.client ?? client).post<QuickPrintResponses, QuickPrintErrors, ThrowOnError>({ url: '/api/printing/quick/{transId}', ...options });

/**
 * List orders eligible for invoice transmission
 */
export const listInvoiceEligibleOrders = <ThrowOnError extends boolean = false>(options?: Options<ListInvoiceEligibleOrdersData, ThrowOnError>) => (options?.client ?? client).get<ListInvoiceEligibleOrdersResponses, unknown, ThrowOnError>({ url: '/api/printing/batch-invoice/eligible', ...options });

/**
 * Start batch invoice transmission (email and/or print)
 */
export const startBatchInvoiceTransmission = <ThrowOnError extends boolean = false>(options: Options<StartBatchInvoiceTransmissionData, ThrowOnError>) => (options.client ?? client).post<StartBatchInvoiceTransmissionResponses, unknown, ThrowOnError>({
    url: '/api/printing/batch-invoice',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start batch goldenrod production ticket print
 */
export const startBatchGoldenrodPrint = <ThrowOnError extends boolean = false>(options: Options<StartBatchGoldenrodPrintData, ThrowOnError>) => (options.client ?? client).post<StartBatchGoldenrodPrintResponses, StartBatchGoldenrodPrintErrors, ThrowOnError>({
    url: '/api/printing/batch-goldenrod',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List print jobs with optional filters
 */
export const listPrintJobs = <ThrowOnError extends boolean = false>(options?: Options<ListPrintJobsData, ThrowOnError>) => (options?.client ?? client).get<ListPrintJobsResponses, unknown, ThrowOnError>({ url: '/api/printing/jobs', ...options });

/**
 * Get a specific print job by ID
 */
export const getPrintJob = <ThrowOnError extends boolean = false>(options: Options<GetPrintJobData, ThrowOnError>) => (options.client ?? client).get<GetPrintJobResponses, GetPrintJobErrors, ThrowOnError>({ url: '/api/printing/jobs/{id}', ...options });

/**
 * Retry a failed print job
 */
export const retryPrintJob = <ThrowOnError extends boolean = false>(options: Options<RetryPrintJobData, ThrowOnError>) => (options.client ?? client).post<RetryPrintJobResponses, RetryPrintJobErrors, ThrowOnError>({ url: '/api/printing/jobs/{id}/retry', ...options });

/**
 * List all configured FolderMill printers
 */
export const listPrinters = <ThrowOnError extends boolean = false>(options?: Options<ListPrintersData, ThrowOnError>) => (options?.client ?? client).get<ListPrintersResponses, unknown, ThrowOnError>({ url: '/api/printing/printers', ...options });

/**
 * Create a new FolderMill printer configuration
 */
export const createPrinter = <ThrowOnError extends boolean = false>(options: Options<CreatePrinterData, ThrowOnError>) => (options.client ?? client).post<CreatePrinterResponses, CreatePrinterErrors, ThrowOnError>({
    url: '/api/printing/printers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a printer configuration
 */
export const deletePrinter = <ThrowOnError extends boolean = false>(options: Options<DeletePrinterData, ThrowOnError>) => (options.client ?? client).delete<DeletePrinterResponses, DeletePrinterErrors, ThrowOnError>({ url: '/api/printing/printers/{printerId}', ...options });

/**
 * Update an existing printer configuration
 */
export const updatePrinter = <ThrowOnError extends boolean = false>(options: Options<UpdatePrinterData, ThrowOnError>) => (options.client ?? client).put<UpdatePrinterResponses, UpdatePrinterErrors, ThrowOnError>({
    url: '/api/printing/printers/{printerId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all acknowledgment templates
 */
export const listAckTemplates = <ThrowOnError extends boolean = false>(options?: Options<ListAckTemplatesData, ThrowOnError>) => (options?.client ?? client).get<ListAckTemplatesResponses, unknown, ThrowOnError>({ url: '/api/printing/ack-templates', ...options });

/**
 * Create a new acknowledgment template
 */
export const createAckTemplate = <ThrowOnError extends boolean = false>(options: Options<CreateAckTemplateData, ThrowOnError>) => (options.client ?? client).post<CreateAckTemplateResponses, unknown, ThrowOnError>({
    url: '/api/printing/ack-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Auto-select the best acknowledgment template for an order
 */
export const selectAckTemplate = <ThrowOnError extends boolean = false>(options: Options<SelectAckTemplateData, ThrowOnError>) => (options.client ?? client).get<SelectAckTemplateResponses, SelectAckTemplateErrors, ThrowOnError>({ url: '/api/printing/ack-templates/select/{transId}', ...options });

/**
 * Delete an acknowledgment template
 */
export const deleteAckTemplate = <ThrowOnError extends boolean = false>(options: Options<DeleteAckTemplateData, ThrowOnError>) => (options.client ?? client).delete<DeleteAckTemplateResponses, DeleteAckTemplateErrors, ThrowOnError>({ url: '/api/printing/ack-templates/{id}', ...options });

/**
 * Update an existing acknowledgment template
 */
export const updateAckTemplate = <ThrowOnError extends boolean = false>(options: Options<UpdateAckTemplateData, ThrowOnError>) => (options.client ?? client).put<UpdateAckTemplateResponses, UpdateAckTemplateErrors, ThrowOnError>({
    url: '/api/printing/ack-templates/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all GL codes
 */
export const accountingListGlCodes = <ThrowOnError extends boolean = false>(options?: Options<AccountingListGlCodesData, ThrowOnError>) => (options?.client ?? client).get<AccountingListGlCodesResponses, unknown, ThrowOnError>({ url: '/api/accounting/gl-codes', ...options });

/**
 * Create a new GL code
 */
export const accountingCreateGlCode = <ThrowOnError extends boolean = false>(options: Options<AccountingCreateGlCodeData, ThrowOnError>) => (options.client ?? client).post<AccountingCreateGlCodeResponses, AccountingCreateGlCodeErrors, ThrowOnError>({
    url: '/api/accounting/gl-codes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a GL code
 */
export const accountingDeleteGlCode = <ThrowOnError extends boolean = false>(options: Options<AccountingDeleteGlCodeData, ThrowOnError>) => (options.client ?? client).delete<AccountingDeleteGlCodeResponses, AccountingDeleteGlCodeErrors, ThrowOnError>({ url: '/api/accounting/gl-codes/{id}', ...options });

/**
 * Get a GL code by ID
 */
export const accountingGetGlCode = <ThrowOnError extends boolean = false>(options: Options<AccountingGetGlCodeData, ThrowOnError>) => (options.client ?? client).get<AccountingGetGlCodeResponses, AccountingGetGlCodeErrors, ThrowOnError>({ url: '/api/accounting/gl-codes/{id}', ...options });

/**
 * Update an existing GL code
 */
export const accountingUpdateGlCode = <ThrowOnError extends boolean = false>(options: Options<AccountingUpdateGlCodeData, ThrowOnError>) => (options.client ?? client).put<AccountingUpdateGlCodeResponses, AccountingUpdateGlCodeErrors, ThrowOnError>({
    url: '/api/accounting/gl-codes/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all payment terms codes
 */
export const accountingListTermsCodes = <ThrowOnError extends boolean = false>(options?: Options<AccountingListTermsCodesData, ThrowOnError>) => (options?.client ?? client).get<AccountingListTermsCodesResponses, unknown, ThrowOnError>({ url: '/api/accounting/terms-codes', ...options });

/**
 * Create a new payment terms code
 */
export const accountingCreateTermsCode = <ThrowOnError extends boolean = false>(options: Options<AccountingCreateTermsCodeData, ThrowOnError>) => (options.client ?? client).post<AccountingCreateTermsCodeResponses, AccountingCreateTermsCodeErrors, ThrowOnError>({
    url: '/api/accounting/terms-codes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a payment terms code
 */
export const accountingDeleteTermsCode = <ThrowOnError extends boolean = false>(options: Options<AccountingDeleteTermsCodeData, ThrowOnError>) => (options.client ?? client).delete<AccountingDeleteTermsCodeResponses, AccountingDeleteTermsCodeErrors, ThrowOnError>({ url: '/api/accounting/terms-codes/{termsCodeId}', ...options });

/**
 * Get a terms code by ID
 */
export const accountingGetTermsCode = <ThrowOnError extends boolean = false>(options: Options<AccountingGetTermsCodeData, ThrowOnError>) => (options.client ?? client).get<AccountingGetTermsCodeResponses, AccountingGetTermsCodeErrors, ThrowOnError>({ url: '/api/accounting/terms-codes/{termsCodeId}', ...options });

/**
 * Update an existing payment terms code
 */
export const accountingUpdateTermsCode = <ThrowOnError extends boolean = false>(options: Options<AccountingUpdateTermsCodeData, ThrowOnError>) => (options.client ?? client).put<AccountingUpdateTermsCodeResponses, AccountingUpdateTermsCodeErrors, ThrowOnError>({
    url: '/api/accounting/terms-codes/{termsCodeId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all payment methods, optionally filtered by division
 */
export const accountingListPaymentMethods = <ThrowOnError extends boolean = false>(options?: Options<AccountingListPaymentMethodsData, ThrowOnError>) => (options?.client ?? client).get<AccountingListPaymentMethodsResponses, unknown, ThrowOnError>({ url: '/api/accounting/payment-methods', ...options });

/**
 * Create a new payment method
 */
export const accountingCreatePaymentMethod = <ThrowOnError extends boolean = false>(options: Options<AccountingCreatePaymentMethodData, ThrowOnError>) => (options.client ?? client).post<AccountingCreatePaymentMethodResponses, AccountingCreatePaymentMethodErrors, ThrowOnError>({
    url: '/api/accounting/payment-methods',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a payment method
 */
export const accountingDeletePaymentMethod = <ThrowOnError extends boolean = false>(options: Options<AccountingDeletePaymentMethodData, ThrowOnError>) => (options.client ?? client).delete<AccountingDeletePaymentMethodResponses, AccountingDeletePaymentMethodErrors, ThrowOnError>({ url: '/api/accounting/payment-methods/{pmtMethodId}/{divisionId}', ...options });

/**
 * Get a payment method by ID and division
 */
export const accountingGetPaymentMethod = <ThrowOnError extends boolean = false>(options: Options<AccountingGetPaymentMethodData, ThrowOnError>) => (options.client ?? client).get<AccountingGetPaymentMethodResponses, AccountingGetPaymentMethodErrors, ThrowOnError>({ url: '/api/accounting/payment-methods/{pmtMethodId}/{divisionId}', ...options });

/**
 * Update an existing payment method
 */
export const accountingUpdatePaymentMethod = <ThrowOnError extends boolean = false>(options: Options<AccountingUpdatePaymentMethodData, ThrowOnError>) => (options.client ?? client).put<AccountingUpdatePaymentMethodResponses, AccountingUpdatePaymentMethodErrors, ThrowOnError>({
    url: '/api/accounting/payment-methods/{pmtMethodId}/{divisionId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List tax calculations with order context, filterable by transaction ID, state, and date range
 */
export const listTaxInquiry = <ThrowOnError extends boolean = false>(options?: Options<ListTaxInquiryData, ThrowOnError>) => (options?.client ?? client).get<ListTaxInquiryResponses, unknown, ThrowOnError>({ url: '/api/accounting/tax/inquiry', ...options });

/**
 * List TaxJar API call logs with tax rate and amount details
 */
export const listTaxJarLog = <ThrowOnError extends boolean = false>(options?: Options<ListTaxJarLogData, ThrowOnError>) => (options?.client ?? client).get<ListTaxJarLogResponses, unknown, ThrowOnError>({ url: '/api/accounting/tax/log', ...options });

/**
 * Get a single TaxJar log entry with full jurisdiction-level tax breakdown
 */
export const getTaxJarLog = <ThrowOnError extends boolean = false>(options: Options<GetTaxJarLogData, ThrowOnError>) => (options.client ?? client).get<GetTaxJarLogResponses, GetTaxJarLogErrors, ThrowOnError>({ url: '/api/accounting/tax/log/{id}', ...options });

/**
 * List orders eligible for posting (status = INVOICE)
 */
export const listPostEligibleOrders = <ThrowOnError extends boolean = false>(options?: Options<ListPostEligibleOrdersData, ThrowOnError>) => (options?.client ?? client).get<ListPostEligibleOrdersResponses, unknown, ThrowOnError>({ url: '/api/accounting/posting/eligible', ...options });

/**
 * Post a batch of invoiced orders — commits tax to TaxJar, writes audit logs, sets status to POSTED
 */
export const executeBatchPost = <ThrowOnError extends boolean = false>(options: Options<ExecuteBatchPostData, ThrowOnError>) => (options.client ?? client).post<ExecuteBatchPostResponses, ExecuteBatchPostErrors, ThrowOnError>({
    url: '/api/accounting/posting/execute',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post a cash receipt payment to Traverse and write PAY audit log
 */
export const postCashReceipt = <ThrowOnError extends boolean = false>(options: Options<PostCashReceiptData, ThrowOnError>) => (options.client ?? client).post<PostCashReceiptResponses, PostCashReceiptErrors, ThrowOnError>({
    url: '/api/accounting/cash-receipts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List invoiced orders eligible for the sales register
 */
export const listSalesRegisterOrders = <ThrowOnError extends boolean = false>(options?: Options<ListSalesRegisterOrdersData, ThrowOnError>) => (options?.client ?? client).get<ListSalesRegisterOrdersResponses, unknown, ThrowOnError>({ url: '/api/accounting/sales-register', ...options });

/**
 * Generate Excel sales register report for invoiced orders in a date range
 */
export const getSalesRegisterReport = <ThrowOnError extends boolean = false>(options?: Options<GetSalesRegisterReportData, ThrowOnError>) => (options?.client ?? client).get<GetSalesRegisterReportResponses, unknown, ThrowOnError>({ url: '/api/accounting/sales-register/report', ...options });

/**
 * Commit invoiced orders to SALE status — transitions INVOICE → SALE with audit trail
 */
export const commitSales = <ThrowOnError extends boolean = false>(options: Options<CommitSalesData, ThrowOnError>) => (options.client ?? client).post<CommitSalesResponses, CommitSalesErrors, ThrowOnError>({
    url: '/api/accounting/sales-register/commit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview undeposited payments grouped by payment method without committing
 */
export const previewDeposits = <ThrowOnError extends boolean = false>(options: Options<PreviewDepositsData, ThrowOnError>) => (options.client ?? client).get<PreviewDepositsResponses, unknown, ThrowOnError>({ url: '/api/accounting/deposits/preview', ...options });

/**
 * Process deposit batch — stamps DepNum on payments and writes DEPOSIT audit log entries
 */
export const executeDeposits = <ThrowOnError extends boolean = false>(options: Options<ExecuteDepositsData, ThrowOnError>) => (options.client ?? client).post<ExecuteDepositsResponses, ExecuteDepositsErrors, ThrowOnError>({
    url: '/api/accounting/deposits/execute',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List TaxJar log entries for the sales tax report
 */
export const listSalesTaxReportEntries = <ThrowOnError extends boolean = false>(options?: Options<ListSalesTaxReportEntriesData, ThrowOnError>) => (options?.client ?? client).get<ListSalesTaxReportEntriesResponses, unknown, ThrowOnError>({ url: '/api/accounting/sales-tax-report', ...options });

/**
 * Generate Excel sales tax report with detail and summary sheets
 */
export const getSalesTaxReport = <ThrowOnError extends boolean = false>(options?: Options<GetSalesTaxReportData, ThrowOnError>) => (options?.client ?? client).get<GetSalesTaxReportResponses, unknown, ThrowOnError>({ url: '/api/accounting/sales-tax-report/report', ...options });

/**
 * List un-deposited payments (PAY/PAYADJ events without matching DEPOSIT records)
 */
export const listDepositReportPayments = <ThrowOnError extends boolean = false>(options?: Options<ListDepositReportPaymentsData, ThrowOnError>) => (options?.client ?? client).get<ListDepositReportPaymentsResponses, unknown, ThrowOnError>({ url: '/api/accounting/deposit-report', ...options });

/**
 * Generate Excel deposit report with detail and summary sheets
 */
export const getDepositReport = <ThrowOnError extends boolean = false>(options?: Options<GetDepositReportData, ThrowOnError>) => (options?.client ?? client).get<GetDepositReportResponses, unknown, ThrowOnError>({ url: '/api/accounting/deposit-report/report', ...options });

/**
 * Commit un-deposited payments — writes DEPOSIT/DEPADJ audit log records
 */
export const commitDeposits = <ThrowOnError extends boolean = false>(options: Options<CommitDepositsData, ThrowOnError>) => (options.client ?? client).post<CommitDepositsResponses, CommitDepositsErrors, ThrowOnError>({
    url: '/api/accounting/deposit-report/commit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search orders and customers via Meilisearch typeahead
 */
export const globalSearch = <ThrowOnError extends boolean = false>(options: Options<GlobalSearchData, ThrowOnError>) => (options.client ?? client).get<GlobalSearchResponses, unknown, ThrowOnError>({ url: '/api/search', ...options });

/**
 * Trigger a full reindex of search data via Hangfire
 */
export const reindexSearch = <ThrowOnError extends boolean = false>(options?: Options<ReindexSearchData, ThrowOnError>) => (options?.client ?? client).post<ReindexSearchResponses, unknown, ThrowOnError>({ url: '/api/search/reindex', ...options });

/**
 * List chat sessions for the current user, optionally filtered by entity
 */
export const listChatSessions = <ThrowOnError extends boolean = false>(options?: Options<ListChatSessionsData, ThrowOnError>) => (options?.client ?? client).get<ListChatSessionsResponses, unknown, ThrowOnError>({ url: '/api/ai/sessions', ...options });

/**
 * Create a new AI chat session, optionally linked to an entity
 */
export const createChatSession = <ThrowOnError extends boolean = false>(options: Options<CreateChatSessionData, ThrowOnError>) => (options.client ?? client).post<CreateChatSessionResponses, unknown, ThrowOnError>({
    url: '/api/ai/sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive (soft delete) a chat session
 */
export const archiveChatSession = <ThrowOnError extends boolean = false>(options: Options<ArchiveChatSessionData, ThrowOnError>) => (options.client ?? client).delete<ArchiveChatSessionResponses, ArchiveChatSessionErrors, ThrowOnError>({ url: '/api/ai/sessions/{id}', ...options });

/**
 * Get a chat session with its message history
 */
export const getChatSession = <ThrowOnError extends boolean = false>(options: Options<GetChatSessionData, ThrowOnError>) => (options.client ?? client).get<GetChatSessionResponses, GetChatSessionErrors, ThrowOnError>({ url: '/api/ai/sessions/{id}', ...options });

/**
 * Update the title of a chat session
 */
export const updateChatSessionTitle = <ThrowOnError extends boolean = false>(options: Options<UpdateChatSessionTitleData, ThrowOnError>) => (options.client ?? client).patch<UpdateChatSessionTitleResponses, UpdateChatSessionTitleErrors, ThrowOnError>({
    url: '/api/ai/sessions/{id}/title',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List messages in a chat session with pagination
 */
export const listChatMessages = <ThrowOnError extends boolean = false>(options: Options<ListChatMessagesData, ThrowOnError>) => (options.client ?? client).get<ListChatMessagesResponses, unknown, ThrowOnError>({ url: '/api/ai/sessions/{sessionId}/messages', ...options });

/**
 * Persist a chat message (called by the AI service after streaming)
 */
export const persistChatMessage = <ThrowOnError extends boolean = false>(options: Options<PersistChatMessageData, ThrowOnError>) => (options.client ?? client).post<PersistChatMessageResponses, PersistChatMessageErrors, ThrowOnError>({
    url: '/api/ai/sessions/{sessionId}/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiAiAdminStats = <ThrowOnError extends boolean = false>(options?: Options<GetApiAiAdminStatsData, ThrowOnError>) => (options?.client ?? client).get<GetApiAiAdminStatsResponses, GetApiAiAdminStatsErrors, ThrowOnError>({ url: '/api/ai/admin/stats', ...options });

export const getApiAiAdminSessions = <ThrowOnError extends boolean = false>(options?: Options<GetApiAiAdminSessionsData, ThrowOnError>) => (options?.client ?? client).get<GetApiAiAdminSessionsResponses, unknown, ThrowOnError>({ url: '/api/ai/admin/sessions', ...options });

export const getApiAiAdminSessionsByIdMessages = <ThrowOnError extends boolean = false>(options: Options<GetApiAiAdminSessionsByIdMessagesData, ThrowOnError>) => (options.client ?? client).get<GetApiAiAdminSessionsByIdMessagesResponses, GetApiAiAdminSessionsByIdMessagesErrors, ThrowOnError>({ url: '/api/ai/admin/sessions/{id}/messages', ...options });

/**
 * List all configured EPSVT cold foil printers
 */
export const listColdFoilPrinters = <ThrowOnError extends boolean = false>(options?: Options<ListColdFoilPrintersData, ThrowOnError>) => (options?.client ?? client).get<ListColdFoilPrintersResponses, unknown, ThrowOnError>({ url: '/api/cold-foil/printers', ...options });

/**
 * Create a new EPSVT cold foil printer configuration
 */
export const createColdFoilPrinter = <ThrowOnError extends boolean = false>(options: Options<CreateColdFoilPrinterData, ThrowOnError>) => (options.client ?? client).post<CreateColdFoilPrinterResponses, CreateColdFoilPrinterErrors, ThrowOnError>({
    url: '/api/cold-foil/printers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an EPSVT printer configuration
 */
export const deleteColdFoilPrinter = <ThrowOnError extends boolean = false>(options: Options<DeleteColdFoilPrinterData, ThrowOnError>) => (options.client ?? client).delete<DeleteColdFoilPrinterResponses, DeleteColdFoilPrinterErrors, ThrowOnError>({ url: '/api/cold-foil/printers/{id}', ...options });

/**
 * Update an existing EPSVT printer configuration
 */
export const updateColdFoilPrinter = <ThrowOnError extends boolean = false>(options: Options<UpdateColdFoilPrinterData, ThrowOnError>) => (options.client ?? client).put<UpdateColdFoilPrinterResponses, UpdateColdFoilPrinterErrors, ThrowOnError>({
    url: '/api/cold-foil/printers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Test connectivity to an EPSVT printer via SOAP
 */
export const testColdFoilPrinterConnection = <ThrowOnError extends boolean = false>(options: Options<TestColdFoilPrinterConnectionData, ThrowOnError>) => (options.client ?? client).post<TestColdFoilPrinterConnectionResponses, TestColdFoilPrinterConnectionErrors, ThrowOnError>({ url: '/api/cold-foil/printers/{name}/test-connection', ...options });
